export default () => {
  var brands = {
    CB: {
      bankName: 'Clydesdale',
      bankCode: 'CB',
      bankWebsite: 'http://www.cbonline.co.uk',
      phoneNumber: '0800 028 3632',
      appendBank: true,
      faqsLink:
        'https://help.cybonline.co.uk/system/selfservice.controller?CONFIGURATION=1125&PARTITION_ID=1&CMD=STARTPAGE&USERTYPE=1&isSecure=true&isSecure=true&LANGUAGE=en&COUNTRY=us',
      monetiseLink:
        'http://www.cbonline.co.uk/personal/current-accounts/nextsteps/',
    },
    DYB: {
      bankName: 'B',
      bankCode: 'B',
      bankWebsite: 'http://www.cbonline.co.uk',
      phoneNumber: '0800 121 7365',
      appendBank: true,
    },
    YB: {
      bankName: 'Yorkshire',
      bankCode: 'YB',
      bankWebsite: 'http://www.ybonline.co.uk',
      phoneNumber: '0800 028 3632',
      appendBank: false,
      faqsLink:
        'https://help.cybonline.co.uk/system/selfservice.controller?CONFIGURATION=1131&PARTITION_ID=1&CMD=STARTPAGE&USERTYPE=1&isSecure=true&isSecure=true&LANGUAGE=en&COUNTRY=us',
      monetiseLink:
        'http://www.ybonline.co.uk/personal/current-accounts/nextsteps/',
    },
    VM: {
      bankName: 'Virgin',
      bankCode: 'VM',
      bankWebsite: 'https://uk.virginmoney.com',
      phoneNumber: '0800 121 7365',
      appendBank: true,
    },
  };

  var appLinks = {
    ios: {
      link: 'http://itunes.apple.com/app/id1051351437',
      title: 'App Store',
    },
    android: {
      link: 'https://play.google.com/store/apps/details?id=co.uk.youandb.android.b',
      title: 'Google Play',
    },
    amazon: {
      link: 'http://www.amazon.co.uk/gp/mas/dl/android?p=co.uk.youandb.android.b',
      title: 'Amazon App Store',
    },
  };

  var brand = brands.VM;

  var result = {
    bankNames: {
      CB: brands.CB.bankName,
      YB: brands.YB.bankName,
      DYB: brands.DYB.bankName,
    },
    appLinks: appLinks,
    bankWebsite: brand.bankWebsite,
    typeLabel: 'Type',
    fromLabel: 'From',
    toLabel: 'To',
    debitAmountLabel: 'Debit amount',
    paymentFeesLabel: 'Payment fees',
    submissionDateLabel: 'Payment submission date',
    exchangeRateLabel: 'Exchange rate',
    actualRateLabel: 'Actual exchange rate',
    sendAmountLabel: 'Send amount',
    settlementDateLabel: 'Earliest estimated settlement date',
    referenceLabel: 'Reason for payment',
    createdByLabel: 'Created by',
    createdOnLabel: 'Created on',
    authorisedByLabel: 'Authorised by',
    feesLabel: 'Fees',
    paymentDateLabel: 'Payment date',
    bacsID: 'BACS Id',
    transactionCodeLabel: 'Transaction Code',
    hmrcReferenceLabel: 'HMRC Reference',
    referencePaymentLabel: 'Reference',
    settlementPaymentDateLabel: 'Settlement Date',

    // MasterCardAlerts
    masterCardPopupWarningHeader: 'Your changes haven’t been made yet',
    masterCardPopupWarningBody:
      'If you leave now, your changes won’t be made and your alerts won’t be updated.',
    masterCardLeavePageBtn: 'Cancel changes',
    masterCardContinuePageBtn: 'Review and confirm changes',

    // Product Links
    productLinkIM540: brand.bankWebsite + '/personal/current-accounts/direct/',
    productLinkIM135:
      brand.bankWebsite + '/personal/current-accounts/current-account-plus/',
    productLinkIM125:
      brand.bankWebsite + '/personal/current-accounts/current-account-control/',
    productLinkIM800:
      brand.bankWebsite +
      '/personal/current-accounts/standard-current-account/',
    productLinkIM136: 'http://www.youandb.co.uk/getb',

    // Document
    documentTitle: brand.bankCode + ' Web',
    navigationWarning:
      "If you refresh or leave this page, you'll lose any unsaved progress. Are you sure you want to leave?",

    // Header Logo
    headerLogoAlt: brand.bankName + ' Bank Logo',

    // Side Progress Bar
    sidebarStep1: 'About you',
    sidebarStep2: 'Your money',
    sidebarStep3: 'All systems go',

    exportTransaction: 'Download transactions',
    paperStatement: 'Order a paper statement',
    chequeBook: 'Order a new cheque book',
    payBook: 'Order a new pay-in book',
    // inline error messages for move money
    nameErrorMessage: 'Enter their name then try again.',
    inlineErrorDangerClass: 'c-field__message alert alert-danger',
    personCompanyErrorMessage:
      'Enter the name of the person or company you want to pay then try again.',
    accountHolderErrorMessage:
      'Enter the name of the person who holds this account.',
    referenceErrorMessage: 'Enter a reference for this payment then try again.',
    sortCodeErrorMessage: 'Enter their six-digit sort code then try again.',
    accountNumberErrorMessage:
      'Enter their eight-digit account number then try again.',
    nicknameErrorMessage:
      'Enter a nickname for the person or company you want to pay then try again.',
    dateErrorMesaage:
      'Choose the date you want to make repeating payment. This should be entered as DD/MM/YYYY.',
    accountTypeErrorMessage: 'Please select Person or Business',
    reviewHeaderMsg:
      'Check the details you have entered are right before you make your payment.',

    paymentType: 'Payment type',
    balanceMsg: 'Balance after payment',

    noOfPayments: 'payments',
    noOfPayment: 'payment',

    noOfTimesEdgeCaseMessage:
      'Oops, that’s too many payments. Enter 300 or less then try again.',
    howOftenErrorMessage: 'Please select one of the options.',
    referenceFieldMsgMoveMoneyTransfer:
      'Add a brief description to remind you why you moved this money. This will appear in your transactions and statements.',

    // company button name
    companyButtonName: 'Add new payment details',
    makePaymentBtn: 'Make a payment to this payee',
    goAcctBtn: 'Go to Accounts',
    goMangePayeeBtn: 'Manage your payees',
    companyAddedMsg1:
      ' has now been added to your list of people and companies you pay.',
    companyAddedMsg2: 'list of people and companies you pay.',

    quikLinkMsg: 'Manage who you pay',
    payeeHeader: 'Pay someone new',
    summaryHeaderTitle: 'New payee added',
    subHeader: 'Who would you like to pay?',
    contactPrefsHeader: 'How would you prefer to be contacted?',
    referenceFieldMsgMoveMoney:
      'They’ll see this. You can add customer references, credit card or roll numbers here (if you have them).',
    reviewHeaderTitleMoveMoney: 'Review your payment',
    softTokenAlternativeHeaderTitleMoveMoney: 'Give this payment the OK',
    softTokenAlternativeHeaderMsg:
      'To continue with this payment, you have to authorise it using your security token.',

    noOfTimesMsg:
      'Enter the number of payments you want to make before this repeating payment stops.',

    editpayeeSumamaryMsg: 'All done. You’re good to go.',
    editPayeeWarningPopup1:
      'The changes you’ve just made will only apply to new payments you make to this person or company in the future. If you’re already paying them by Direct Debit or standing order, you’ll need to update those details too.',
    editPayeeWarningPopup2:
      'You can update a standing order online but if you want to change a Direct Debit, you’ll have to get in touch with the company you’re paying to make the changes for you.',

    deletePopupHeading: 'Sure you want to delete them?',
    deletePayeePopUp1:
      'You’re about to delete the following person or company. This won’t affect any scheduled payments you’ve got set up for them.',
    deletePayeePopUp2:
      'If you want to cancel a scheduled payment, like a Direct Debit or standing order, go ahead and ',
    deletePayeePopUp3: 'manage your scheduled payments',
    deletePopupBtn: 'Delete',
    payeePoupDeleted:
      ' has now been deleted from your list of people and companies you pay.',

    viewPaymentHeader: 'Manage your scheduled payments',

    emptyDDListMsg: "You don't have any scheduled payments.",
    emptySOListMsg: "You don't have any scheduled payments.",
    emptyOtherListMsg: "You don't have any scheduled payments.",

    footerDDListMsg: 'Any new scheduled payments you set up will appear here.',
    footerSOListMsg: 'Any new scheduled payments you set up will appear here.',
    footerOtherListMsg:
      'Any new scheduled payments you set up will appear here.',

    activeFooter:
      "That's all of them. Any new scheduled payments you set up will appear here.",

    alternativeText: ' enter their sort code and account number',
    alternativeCompanyText: " search using the company's name",

    siteHeaderModalTitle: "Your {paymentType} hasn't been made yet",

    referenceNumberTextAddPayee:
      'They’ll see this. You can add customer references, credit card or roll numbers here (if you have them).',

    addPayeeBTn: 'Add new payment details',
    reviewSOMsg:
      '<strong> {oftenText} </strong> starting from <strong> {startDate} </strong> and stopping <strong> {endDateLabel} </strong>',
    reviewSOMsg1:
      '<strong> {oftenText} </strong> starting from <strong> {startDate} </strong> and stopping <strong> on {endDateLabel} </strong>',

    managePageheaderTitle: 'Manage who you pay',
    editPageheaderTitle: 'Edit details',

    limitLink: 'How much can I move?',
    apply: '',
    amountEdgeCaseErrorMessage:
      'Sorry, you’re not allowed to move that much online in one transaction. You can see how much you can move in the FAQs.',
    // Key Features
    noMonthlyFee: 'There is no monthly fee for this account.',
    noMonthlyFeeOrCharges: 'There are no fees or charges for this account.',
    monthlyFee:
      'A monthly maintenance fee of £2 applies to the our banking service and will be applied following a 12 month free period. Full details can be found in your terms and conditions and in your tariff.',
    variableCreditInterest:
      'Variable credit interest is payable on this account on credit balances.',
    noCreditInterest: "This account doesn't pay credit interest.",
    interestUpTo3000:
      'Interest is payable on this account on credit balances up to £3000.',
    noUnplannedBorrowing:
      'Borrowing is not available on this account. Requests for unplanned borrowing will usually be declined. An item returned unpaid costs £15. Full details can be found in the borrowing section of your terms and conditions and in your tariff.',
    plannedBorrowing125:
      'Planned borrowing is available on this account, subject to eligibility. The cost of this is £6 per month plus interest. Requests for unplanned borrowing will usually be declined. Full details can be found in the borrowing section of your terms and conditions and in your tariff.',
    plannedBorrowing:
      'Borrowing is available on this account, subject to eligibility, and is usually more expensive if not agreed in advance. Planned borrowing costs £6 per month plus interest. Unplanned borrowing costs £6 per day. An item returned unpaid costs £15. Full details can be found in the borrowing section of your terms and conditions and in your tariff.',
    fscsCovered:
      'Your eligible deposits with Virgin Money PLC are protected up to a total of £85,000 by the Financial Services Compensation Scheme, the UK\'s deposit guarantee scheme. This limit is applied to the total of any deposits you have with Virgin Money PLC brands, including Clydesdale Bank, Yorkshire Bank and B. Any total deposits you hold above the limit between these brands are unlikely to be covered. Please see <a href="http://www.cbonline.co.uk/resources/b82e172a-b00f-4783-973b-e4399da349e4/fscs_2015_online-leaflet.pdf" target="_blank" title="www.fscs.org.uk. This link will open in a new browser window">FSCS leaflet<span class="screenreader"> This link will open in a new browser window</span></a> for further information or visit <a href="http://www.fscs.org.uk" target="_blank" title="www.fscs.org.uk. This link will open in a new browser window">www.fscs.org.uk<span class="screenreader"> This link will open in a new browser window</span></a>',
    defaultCancellationPolicy:
      'You can cancel your agreement with us within 14 days of opening the account, or from the day you receive the terms and conditions, if later, by contacting us in branch, by phone or in writing.  You will need to repay any debit balance, interest and fees incurred within 30 days of the date you tell us you want to cancel it.',
    mortgageSaver:
      'Both the Virgin Money Current Account and Virgin Money Instant Savings account are eligible for inclusion in mortgage offsetting arrangements. Any credit balance can be used to set against the debit balance on your Offset Mortgage held with us and so reduce the interest payable on your mortgage. Full details can be found in the Offsetting section of your terms and conditions',
    accountClosureInfo:
      "If you close all of your Virgin Money Current Accounts, you'll no longer have access to the mobile app (unless you hold another account that we agree can be used to access the app) and your Virgin Money Instant Savings accounts will be closed or transferred to another instant savings account.",
    caDirectKeyFeature:
      'This account requires a minimum deposit of £1000 per month (excluding transfers from other accounts held with us), and that you must register for telephone and internet services and use these for day-to-day banking. Please note, if you fail to meet these criteria, we may change your account to a Current Account Plus which has different interest rates.',
    caDirectKeyFeature2:
      'You can have a maximum of 2 Current Account Direct accounts, of which only one may be a sole account.',

    // Key Features Virgin Money
    keyFeatureRequirements:
      'You are applying for both a Virgin Money Current Account and a Virgin Money Instant Savings account. Both are required to take full advantage of all the features of internet banking and our app.',
    keyFeatureRequirementsB:
      'You will need both a compatible tablet and compatible mobile phone to access the full range of services available in the app, though other mobile phones can still be used to receive text alerts',
    keyFeatureCreditIterest:
      'Credit interest is payable on both the current and the savings account; please refer to your Tariff for rates.',
    keyFeatureTransfer:
      'If you want to take money out of your Virgin Money Instant Savings account, you need to transfer the money into your Virgin Money Current Account first and make your payment from there. You will be able to make transfers from your Virgin Money Instant Savings account to some other accounts you hold with us',
    keyFeatureNoDirectDebitSavings:
      'No standing orders or Direct Debits can be set up on your Virgin Money Instant Savings account',
    keyFeaturesComplaints:
      'We are committed to providing our customers with the best possible service but more information can be found in the terms and conditions about what to do if you have a complaint.',
    serviceCommitmentB:
      'We are committed to providing our customers with the best possible service but more information can be found in the terms and conditions about what to do if you have a complaint. ',
    overdraftFacilityB:
      'Borrowing is available on the Virgin Money Current Account, subject to eligibility.  Going overdrawn is usually more expensive if not arranged in advance. Planned borrowing costs £6 per month plus interest. Unplanned borrowing costs £6 per day. An item returned unpaid costs £15. Full details can be found in your terms and conditions and in your tariff. Borrowing is not allowed on the Virgin Money Instant Savings account.',
    packagedAccountOpening:
      'Both a Virgin Money Current Account and a Virgin Money Instant Savings account will be opened at the same time so you can take full advantage of all the features we offer.',
    creditInterestPaid:
      'Credit interest is payable on both the current and the savings account; please refer to your tariff for rates.',
    savingsWithdrawals:
      'You can’t make withdrawals directly from your Virgin Money Instant Savings. You need to first transfer money into your Virgin Money Current Account and make the payment from there. You can transfer money from your Virgin Money Instant Savings account to your Virgin Money Current Account, or any other account that we allow you to make a transfer into using one of our services. Apart from these transfers, you won’t be able to make payments directly to other accounts from Virgin Money Instant Savings. No standing orders or Direct Debits can be set up on your Virgin Money Instant Savings account.',
    creditBalanceMortgage:
      'Any credit balance in this account may be used to reduce the debit interest calculated on your mortgage account with us.',
    noticeOfChanges:
      'We will usually give you two months’ notice of any changes. The terms and conditions detail any that we may make sooner.',

    downgradedOfferPageKeyFeaturesTitle: 'Key features for the',
    downgradedOfferKeyFeaturesParagraph:
      'This section contains certain key information relating to this alternative offer of a Readycash account. Full details are contained in your terms and conditions and tariff attached below which you should read.',

    // Offer Restrictions ReadyCash
    noCheckbook: 'Chequebook facilities.',
    noMortgageOffset: 'The ability to offset against a mortgage product.',
    noLinkedSavings: 'Linked savings account.',
    noBapp: 'The Virgin Money app.',

    // SideBar
    sideBarTitle: 'Need help?',
    sideBarContentLine1: 'Call us on:',
    sideBarContentLine2: '0800 121 7365',
    sideBarContentLine3: 'Monday to Sunday 8am to 8pm.',
    sideBarContentLine4: undefined,
    sideBarContentLine5: undefined,

    // Footer
    footerLinkText1: 'Footer Link 1',
    footerLinkUrl1: '/',
    footerLinkText2: 'Footer Link 2',
    footerLinkUrl2: '/',
    footerLinkText3: 'Footer Link 3',
    footerLinkUrl3: '/',
    footerLinkText4: 'Footer Link 4',
    footerLinkUrl4: '/',

    // Landing Page
    landingPagePageHeader: 'Virgin Money',
    landingPageTitle: "You're applying for a ",
    landingPageIntro:
      "By the time you're finished, if all goes to plan, you should be all set up with a Virgin Money Current Account, Virgin Money Instant Savings account and Virgin Money debit card. You'll need to register for internet and telephone banking and will also have the option to use the Current Account Switch Service.",
    landingPageIntro1:
      'Please be aware our online application does not currently offer the ability to arrange an overdraft. If you require an overdraft and are planning to use the Current Account Switch Service, please call us or go into a branch.',
    landingPageQuestionsNote:
      'If you’re experiencing difficulties or there are other special circumstances related to your application, then it may be that our basic banking Readycash account may suit your needs. If you think this is the case, please call us on 0800 678 3654 or call into one of our branches.',
    existingCustomerTitle: 'Existing customer?',
    initialQuestionsTitle: 'First, a few questions.',
    initialQuestionsSubtitle: undefined,
    infoToApplyTitle: 'Apply',
    infoToApplyIntro:
      "Before you start you'll need about 15 minutes and a few facts at your fingertips:",
    infoToApply1: "Where you've lived",
    infoToApply2: 'What you do for a living',
    infoToApply3: 'General information about your income and expenditure',
    infoToApply4: 'General information about your financial history',
    infoToApply5: '',
    isExistingCustomer:
      'Have you ever held an account with ' + brand.bankName + ' Bank?',
    isExistingCustomerHelpMessage:
      'Even if you held this account in the past, please select Yes.',
    isExistingCustomerValidationMessage:
      "Sorry, you can't apply online, so please call us instead and apply over the phone. Or, if you prefer, go into a branch and ask for help there.",

    infoToApplyFooter1: "Great. Let's go.",

    // Eligibility Questions
    eligibilityAge18Question: 'Are you 18 or over?',
    eligibilityAge18QuestionValidationMessage:
      "As you're under 18 please call, or pop into your local branch for a chat.",
    eligibilityAge18QuestionHelpMessage:
      "To sign up for Virgin Money online you need to be 18 or over. So if you're 16 or 17 you'll need to pop into a local branch to go through your options.",
    eligibilityAge16Question: 'Are you 16 or over?',
    eligibilityAge16QuestionValidationMessage:
      'Sorry, but if you\'re under 16 we can\'t offer you this account at the moment. But we do have some other products that might be of interest. Click on the link to find out more: <a href="javascript:void(0)">CA Plus</a> &amp; <a href="javascript:void(0)">Jumpstart</a>',
    eligibilityAge16QuestionHelpMessage:
      'You need to be 16 or over to have a bank account.',

    eligibilityUKResidentQuestion: 'Do you live in the UK?',
    eligibilityUKResidentQuestionValidationMessage:
      "We need to ask you a few questions we can't cover online. Can you please call us and we'll explain what's involved.",
    eligibilityUKResidentQuestionHelpMessage:
      "You can answer Yes if you are a UK resident. Even if you were born abroad or used to live outside the UK. Feel free to call if you're unsure about anything.",
    eligibilityDeviceQuestion:
      'Got the right device? Are you sure our app will work on both your tablet and mobile phone?',
    eligibilityDeviceQuestionValidationMessage:
      'You will need both a compatible tablet and a compatible mobile phone to take full advantage of all the features of our  app, though other mobile phones can still be used to receive text alerts',
    eligibilityDeviceQuestionHelpMessage:
      'For details of the operating systems and example mobile and tablet devices supported by our app, please visit: <a href="http://www.youandb.co.uk/devices" target="_blank" title="www.youandb.co.uk/devices. This link will open in a new browser window">www.youandb.co.uk/devices <span class="screenreader">This link will open in a new browser window</span></a>.',

    // Terms & Conditions
    eligibilityTermsTitle: 'Using your personal information',
    eligibilityTerms1:
      'The information you provide will be used to assess your application, and set up and manage your accounts.',
    eligibilityTerms2:
      'A full description of how and for what purposes your information may be processed <a href="static/DU1950.pdf" target="_blank" title="Download Personal Information Statement PDF. This link will open in a new browser window" aria-label="Download Personal Information Statement PDF. This link will open in a new browser window.">can be viewed here <span class="screenreader">Download Personal Information Statement PDF. This link will open in a new browser window</span></a>.',
    eligibilityTerms3:
      'We will share your information with credit reference agencies to help determine what credit products and services we can provide you. These agencies will use the information for assessing credit applications, debt tracing and prevention of money laundering.',
    eligibilityTerms4:
      'If false or inaccurate information is provided and fraud is identified, details will be passed to fraud prevention agencies to prevent fraud and money laundering. Further details explaining how the information is held by fraud prevention agencies can be found in our Use of Personal Information Statement.',
    eligibilityTermsClosingText: undefined,
    acceptTsAndCs: 'I agree to the Use of Personal Information above.',
    dataProtectionDocDownloadLabel: 'Download as PDF',
    dataProtectionDocLink: 'static/DU1950.pdf',
    dataProtectionDocLinkTitle:
      'Download Personal Information Statement PDF. This link will open in a new browser window.',
    dataProtectionDocFileName: 'DU1950.pdf',
    dataProtectionDocVersion: 'I',

    // Step 1 - Your Details
    personalDetailsPageHeader: 'Personal details',
    personalDetailsTitle: 'Now for some form filling',
    personalDetailsGuidance:
      "As part of our security measures you aren't able to change your details at this stage. But don't worry, if anything needs updating please call us on " +
      brand.phoneNumber +
      '.',
    personalDetailsSubtitle: undefined,

    titleQuestion: 'Title',
    titleHelpMessage: 'Please select from the given list.',
    firstNameQuestion: 'First Name',
    firstNameValidationMessage: 'Please use letters and spaces only.',
    firstNameHelpMessage:
      'Just using letters and spaces as it appears on your passport or driving licence.',
    hasMiddleNameQuestion: 'Do you have a middle name?',
    hasMiddleNameHelpMessage:
      'Just using letters and spaces as it appears on your passport or driving licence.',
    middleNameQuestion: 'Middle Name',
    middleNameValidationMessage: 'Please use letters and spaces only.',
    lastNameQuestion: 'Last Name',
    lastNameValidationMessage: 'Please use letters and spaces only.',
    lastNameHelpMessage:
      'Please use your last name as it appears in your passport or driving licence.',
    dateOfBirthQuestion: 'Date of birth',
    dateOfBirthValidationMessage: 'You need to be at least 18 to register.',
    dateOfBirthHelpMessage:
      "To sign up for Virgin Money online you need to be 18 or over. So if you're  16 or 17 you'll need to pop into a local branch to go through your options.",
    genderQuestion: 'Gender',
    genderHelpMessage: 'This is just to help identify you.',
    genderValidationMessage:
      'Please confirm if your title and gender are both correct on ' +
      brand.phoneNumber,
    maritalStatusQuestion: 'Marital status',
    maritalStatusHelpMessage: 'This is just to help identify you.',
    hasDependantsQuestion: 'Do you have any dependants?',
    hasDependantsHelpMessage:
      'A dependant is anyone who relies on your help and support - a child for instance.',
    personalDetailsFoundValidationMessage:
      'You look familiar... If you\'re already a customer <a href="{websiteBaseDirectory}account-opening/authentication?applyFor={productCode}">please login to continue</a>.',

    // Step 1 - Addresses
    addressTitle: 'Where do you live?',
    addressSubtitle:
      "If you've lived at this address for less than three years, you'll need to add your other previous addresses too.",
    postcodeQuestion: 'Postcode',
    addressLookupError:
      'We were unable to look up your postcode. Please try again or contact us to proceed.',
    addressNoExactMatch: "Don't see your exact address? Contact us to proceed.",
    previousAddressTitle: 'Previous address',
    previousAddressSubtitle:
      "We need to know where you've been living for the last 3 years.",
    residentialStatusHelpMessage:
      'Choose the option that best describes your situation, so for instance if you pay a mortgage choose Owner.',
    residentialStatusValidationMessage:
      'Please select an option from the dropdown list.',
    residentialStatusQuestion: 'Living arrangement',
    dateMovedQuestion: 'When you moved here',
    removeAddressButtonLabel: 'Remove Address',
    postcodeSearchButtonLabel: 'Find address',
    postcodeSearchLegend: 'Postcode',
    selectAddressPlaceholder: 'Please select your address...',
    selectAddressLabel: 'Select your address',
    selectAddressSelectButtonText: 'Select',
    addressesQuestion: 'Postcode',
    addressTypeQuestion: 'Did you live in the UK?',
    addressInvalidMessage:
      "Something isn't right with your postcode, please contact the team at " +
      brand.bankName +
      ' on ' +
      brand.phoneNumber,

    // Step 1 - Contact Details
    contactDetailsTitle: 'Now for your contact details',
    contactDetailsIntro:
      'Please give the mobile phone number and email address you want to be used in future.',
    phoneNumberQuestion: 'Mobile number',
    phoneNumberValidationMessage:
      'This should be 11 characters long and numbers only. No spaces or symbols.',
    phoneNumberHelpMessage:
      'This should be 11 numbers long with no spaces or symbols. You must give a mobile number to be able to use our app in full.',
    emailAddressQuestion: 'Email address',
    emailAddressValidationMessage:
      "Hmm. Can you check your email address please? Looks like there's a typo in there somewhere.",
    emailAddressHelpMessage:
      "If you don't want to receive offers by email tell us in the 'How would you like to be contacted?' section below. We'll still need your email address to send you important documents, including your terms and conditions.",
    emailAddressConfirmationQuestion: 'Confirm email address',
    emailAddressConfirmationValidationMessage:
      "Oops. Your email address doesn't match with the first. Can you give it another go?",
    emailAddressConfirmationHelpMessage:
      'Please type your email address again. Thanks.',
    contactMethodTitle: 'How would you like to be contacted?',
    contactMethodIntro:
      "Tell us how we can get in touch with you. When it comes to security, we will always try to contact you on your mobile. You'll never get a request for your login details by email or text.",
    preferredContactMethodQuestion: "I'd prefer to be contacted by",
    contactMethodsValidationMessage:
      'Please select at least one contact method.',

    // Step 1 - Select Your Bank
    selectBankTitle: 'If you ever need to see us',
    selectBankQuestion: 'Which bank is handy for you?',
    selectBankSubtitle:
      'You’ll be able to manage your account online and you can call us too, but if you ever need to see us in person use the links below to find your nearest branch now.',
    bankIDHelpMessage:
      "Please select one of the banks, which seems the best fit for your location. Please call us if you're not sure.",
    bankIDValidationMessage: 'This is required.',
    selectBankHelpText:
      'For CHAPS and international payments, plus some other transaction types, you’ll have to visit your local branch.',

    selectBankHelpLinkCb: 'http://www.cbonline.co.uk/personal/online-locator/',
    selectBankHelpLinkCbText: 'Clydesdale Bank Branch Locator',
    selectBankHelpLinkCbTitle:
      'Clydesdale Bank Branch Locator link. This link will open in a new browser window',
    selectBankHelpLinkYb: 'http://www.ybonline.co.uk/personal/online-locator/',
    selectBankHelpLinkYbText: 'Yorkshire Bank Branch Locator',
    selectBankHelpLinkYbTitle:
      'Yorkshire Bank Branch Locator link. This link will open in a new browser window',

    // Step 1 - Username and Password
    // setPasswordTitle: 'Your username and password',
    setPasswordTitle: 'Set up your password',
    usernameInfo:
      "When you create your username and password make sure they’re memorable, as you'll need them to log on in future, for internet banking and signing up to our app. The username you choose can't be changed and we won't be able to remind you of it if you forget it.",
    additionalUsernameInfo:
      "Once you've set them you'll be able to save your application form and log back in if you need to take a break.",
    unsavedUsernameHelpMessage:
      "Your username must be 6-16 characters in length, using only letters and numbers. It's also case sensitive.",
    unsavedUsernameValidationMessage:
      "Your username must be 6-16 characters in length, using only letters and numbers. It's also case sensitive.",
    usernameAlreadyInUseValidationMessage:
      'Sorry, that username happens to be already in use.',
    password1Question: 'Password',
    password2Question: 'Password (confirm)',
    passwordRequirements:
      "Your password should be 8-16 characters long with at least one letter, number and symbol. It's case sensitive too.",
    password1HelpMessage:
      "Your password should be 8-16 characters long with at least one letter, number and symbol. It's case sensitive too.",
    password1ValidationMessage:
      "It needs to be tougher than that. Your password should be 8-16 characters long with at least one letter, number and symbol. It's case sensitive too.",
    password2HelpMessage:
      "Your password should be 8-16 characters long with at least one letter, number and symbol. It's case sensitive too.",
    password2ValidationMessage:
      "Oops. Your passwords don't match. Please have another go.",
    passwordDisclaimer:
      'If you have to leave the application for any reason and want to save and log back in later, you can use the same password to login. This password will also be the one you use to sign up to our app.',
    passwordLastWarning:
      'Never give your security details to anyone either in person, by email or by text. Virgin Money will NEVER email or text you asking for username or password, or for details of your accounts or cards.',

    // Employment Details
    employmentDetailsHeader: 'Employment details',
    employmentDetailsTitle: 'Employment details',
    employmentSectionTitle: 'You and your money',
    employmentSectionSubtitle: undefined,
    employmentSectionIntro: '',

    employmentStatusQuestion: 'Job status',
    employmentStatusHelpMessage:
      'Choose an option that best describes your job.',
    employmentOccupationHelpMessage: 'Which occupation is closest to yours?',
    employmentStartDateQuestion: 'When did you start work there?',
    employmentStartDateValidationMessage:
      'Sorry, your employment date doesn’t seem right. Try again?',
    employmentStartDateHelpMessage: 'What was your start date at this job?',
    employerNameValidationMessage:
      'Oops! You missed one. Please fill this in to keep going.',
    employerNameHelpMessage:
      'If you work for yourself just put your own name here',

    // Employment Details - Nationality
    nationalityTitle: 'Where are you from?',
    nationalityQuestion: 'Your nationality',
    nationalityHelpMessage: 'Please select your country of nationality.',
    cityBorn: 'City or town where you were born?',
    cityBornValidationMessage:
      'Letters and spaces only. No numbers or characters.',
    cityBornHelpMessage:
      "As it's written on your birth certificate or passport.",
    countryBorn: 'Country where you were born?',
    countryBornHelpMessage:
      "As it's written on your birth certificate or passport.",
    ukCitizen: 'Do you have a UK citizenship?',
    ukCitizenValidationMessage:
      'You must be a UK citizen in order to open an account.',
    ukCitizenHelpMessage:
      "If you have a UK passport you definitely have UK citizenship. If you have a visa and you're not sure if it covers citizenship please call us on " +
      brand.phoneNumber +
      '.',
    hasAdditionalCitizenships:
      'Are you a citizen of any other country or countries?',
    hasAdditionalCitizenshipsValidationMessage:
      "If you're not a UK citizen, please tell us where you're from.",
    hasAdditionalCitizenshipsHelpMessage:
      "If you're a legally registered citizen of another country please tell us below.",
    citizenshipListQuestion: 'What country or countries?',
    citizenshipListValidationMessage:
      "Please select a country from each of the additional citizenship options you've selected.",

    // Employment Details - Tax
    taxObligationsTitle: 'Now for your tax status',
    taxStatusIntro:
      "Don't worry, this information won't be shared. If you're not sure about anything call us on " +
      brand.phoneNumber +
      '.',
    hasNoTaxOligations: 'Are you a UK tax resident only?',
    hasNoTaxOligationsHelpMessage:
      'Choose "no" if you are not a UK tax resident OR if you have tax obligations in any country in addition to the UK.',
    taxCountryHelpMessage:
      'Which country(ies) do you have a tax obligation in? Please ensure you include details of all countries of tax residency, including the UK',
    taxNumberHelpMessage:
      'This is a code or number that is associated with your tax obligation, usually issued by the tax authority of your country of tax residence. It is mandatory that, if your country of tax residency does issue a tax ID number or equivalent, you must provide this for the country entered. If you do not know what this is, or do not have a tax ID for other reasons,  please call us.',
    allTaxObligationsListed:
      'I confirm that I have no tax obligations other than in the countries listed above.',
    allTaxObligationsListedValidationMessage:
      "Please list all the ways you're liable for tax.",
    allTaxObligationsListedHelpMessage:
      "If you've got a tax obligation that doesn't fit these options, please call us.",
    taxObligationListValidationMessage:
      "Please list all the ways you're liable for tax.",
    taxNumberNA: 'Country of Tax Residency does not issue a Tax ID number',
    taxNumberMissing: 'I do not have my Tax ID Number here',
    taxObligationsListCountryFieldName: 'Country of tax residency',
    taxObligationsListHasTaxNumberFieldName:
      'Does your country of tax residency issue a tax ID number?',
    taxObligationsListTaxNumberName: 'Tax ID',
    taxNumber0ValidationMessage:
      'Letters and numbers only (no symbols or punctuation)',
    taxNumber1ValidationMessage:
      'Letters and numbers only (no symbols or punctuation)',
    taxNumber2ValidationMessage:
      'Letters and numbers only (no symbols or punctuation)',
    taxNumber3ValidationMessage:
      'Letters and numbers only (no symbols or punctuation)',
    taxNumber4ValidationMessage:
      'Letters and numbers only (no symbols or punctuation)',

    // Employment Details- Income
    incomeSectionTitle: 'Money coming in',
    grossAnnualIncome: 'Roughly how much do you earn a year before tax?',
    grossAnnualIncomeValidationMessage:
      'Keep it simple please. No dots, commas or even a £.',
    grossAnnualIncomeHelpMessage:
      "If you're working, please enter your annual salary before tax. Otherwise please enter zero.",
    netMonthlyIncome:
      'Approximately how much goes into your bank account a month, after tax?',
    incomeSectionCurrentAccountSubtitle: 'Current account details',
    incomeSectionSavingsAccountSubtitle: 'Saving up',
    incomeSectionSavingsAccountIntro:
      "Imagine you could put some money aside to do more of the things you've always wanted to do.",
    netMonthlyIncomeValidationMessage:
      'Keep it simple please. No dots, commas or even a £. If your income goes up and down just type in an average. Your monthly income shouldn’t be more than your annual income divided by 12.',
    netMonthlyIncomeHelpMessage:
      'This is the amount you receive each month after tax and deductions. You can include the following incomes: salary, pensions and state benefits (such as disability living allowance, personal independence payment, carers allowance, reduced earnings allowance).',
    hasAdditionalIncome:
      'Aside from the above, do you bring in extra income from anything else?',
    hasAdditionalIncomeValidationMessage: 'Please select an answer.',
    hasAdditionalIncomeHelpMessage:
      "You might get rent in from somewhere or maybe you get interest from investments? If it's something that you declare on your tax returns, you should add it here.",
    incomeOtherAmount: 'What does that extra income add up to over a year?',
    incomeOtherAmountValidationMessage:
      'Please estimate how much extra income you earn a year, not including your salary.',
    incomeOtherAmountHelpMessage:
      "Try to come up with a rough estimate that doesn't include your salary.",
    incomeOtherFrequency: 'That money tends to come in',
    incomeOtherFrequencyOptionsHelpMessage:
      "It's possible that income might come unpredictably or at different times. If there is an option that makes sense for the majority of your payments, please choose it. Otherwise, please call us.",

    incomeOtherSavingsAmount: 'How much might you be able to put away a year?',
    incomeOtherSavingsAmountValidationMessage:
      'Put in a whole number please, without spaces or commas. For example 5000.',
    incomeOtherSavingsAmountHelpMessage:
      "Tell us an overall amount you hope to save annually. If you're not sure, add in a realistic number, perhaps based on previous savings habits.",
    incomeOtherSavingsFrequency: 'How often would you like to put money aside?',
    incomeOtherSavingsFrequencyHelpMessage:
      "If you're not sure, pick an interval that seems most likely. This is just to get you started.",

    incomeOtherPaymentAmount: 'How much will you pay in each month?',
    incomeOtherPaymentAmountValidationMessage:
      'Put in a whole number please, without spaces or commas. For example 3000.',
    incomeOtherPaymentAmountHelpMessage:
      'This is an overall monthly figure which indicates how much income you plan to pay into your new account.',
    incomeOtherAccountPurpose:
      'What is your main reason for having an account with B?',
    incomeOtherAccountPurposeHelpMessage:
      'Please select the main reason for having this account. If there are a few reasons there that make sense to you, just pick one you know is important.',
    incomeOtherAccountPurposeValidationMessage: 'Please select an answer.',
    incomeOtherPaymentType:
      'What will you pay in? Will it be your salary or another source of income?',
    incomeOtherPaymentTypeOptionsHelpMessage:
      'Choose the option that feels the most relevant one to you. This should incorporate all your income sources.',
    incomeOtherPaymentTypeOptionsValidationMessage:
      'Please select one of the options.',

    // Employment Details - Expenses
    expenditureSectionTitle: 'And money going out',
    mortgageOrRentExpenditure:
      'How much do you pay a month on the mortgage and/or rent?',
    mortgageOrRentExpenditureValidationMessage:
      'Please type in a whole number for the overall monthly amount, for example 1200.',
    mortgageOrRentExpenditureHelpMessage:
      'Just the basic figure, not extras like council tax, heating bills or service charges.',
    expenditureOther:
      'Roughly how much do you pay out on personal loans, credit cards and hire purchase agreements?',
    expenditureOtherValidationMessage:
      'Please type a figure without adding any pence, dots or commas.',
    expenditureOtherHelpMessage:
      'The amount you enter here should be the total monthly amount you pay on any personal loans, credit cards and hire purchase agreements.',

    // Review Page
    reviewPageHeader: 'Review',
    reviewTopTitle: 'Review and submit your application',
    reviewTopSubtitle: 'Almost there. Now for a quick review.',
    reviewTopParagraph:
      "Please double-check that your contact details are all correct in the summary below. Some you’ll be able to edit yourself but if anything's not quite right please call us on " +
      brand.phoneNumber +
      ' and ask us to make changes for you. ',
    reviewTopTermsParagraph:
      'Please read all the important information below. It includes the key features, terms and conditions, lending code information and tariff details.',
    reviewPageTitle: 'Review and submit your application',

    reviewPersonalDetailsTitle: 'Your details',
    reviewSectionPersonalTitle: 'About you',
    reviewSectionContactTitle: 'Contact details',
    reviewSectionNationalityTitle: 'Where you are from',
    reviewEmploymentDetailsTitle: 'Employment details',
    reviewSectionEmploymentTitle: 'Employment details',
    reviewSectionIncomeTitle: 'Your money',
    reviewSectionOutgoingsTitle: 'Money out',
    reviewTermsDocumentsTitle: 'Documents for you to read and save',
    reviewTermsDocumentsParagraph:
      'We will also email you these four documents after you have opened a ',
    reviewImportantInformationTitle: 'Important information',

    termsAndConditionsDocLinkText: 'Terms and conditions',
    termsAndConditionsDocLinkTitle:
      'Download terms and conditions PDF. This link will open in a new browser window.',
    termsAndConditionsDocLink: 'static/{}/personal-account-terms.pdf',
    termsAndConditionsDocFileName: 'personal-account-terms.pdf',
    termsAndConditionsDocVersion: '0916',
    lendingCodeDocLinkText: 'A guide to the Lending Code',
    lendingCodeDocLinkTitle:
      'Download Lending Code PDF. This link will open in a new browser window.',
    lendingCodeDocLink: 'static/lending-code.pdf',
    lendingCodeDocFileName: 'lending-code.pdf',
    lendingCodeDocVersion: '1.0',
    currentTariffDocLinkText: 'Tariff details',
    currentTariffDocLinkTitle:
      'Download tariff details PDF. This link will open in a new browser window.',
    currentTariffDocLink: 'static/{}/current-account-tariff.pdf',
    currentTariffDocFileName: 'current-account-tariff.pdf',
    currentTariffDocVersion: '0916',
    CA31DocLink: 'static/{}/CA31.pdf',
    CA31DocLinkText: 'Current account control factsheet',
    CA31DocLinkTitle:
      'Download current account control factsheet PDF. This link will open in a new browser window.',
    CA31DocVersion: '1.0',
    financialServicesCompensationSchemeDocLinkText:
      'Financial Services Compensation Scheme information sheet',
    financialServicesCompensationSchemeDocLinkTitle:
      'Download Financial Services Compensation Scheme information sheet PDF. This link will open in a new browser window.',
    financialServicesCompensationSchemeDocLink:
      'static/FSCS_Information_Sheet_DU728.pdf',
    financialServicesCompensationSchemeDocName:
      'FSCS_Information_Sheet_DU728.pdf',
    financialServicesCompensationSchemeDocVersion: '1215',
    reviewKeyFeaturesTitle: 'Key features for the',
    reviewOfferRestrictionsTitle: "This offer doesn't include:",
    reviewAcceptTsAndCs:
      'By ticking this box and clicking "Submit" this represents my signature confirming that:',

    // Review page labels - capital LABEL so last section can match up to name of the form element
    reviewLabelsectionPersonalDetails: 'Personal details',

    reviewLabeltitle: 'Title',
    reviewLabelfirstName: 'First name',
    reviewLabelmiddleName: 'Middle name',
    reviewLabellastName: 'Last name',
    reviewLabeldateOfBirth: 'Date of birth',
    reviewLabelgender: 'Gender',
    reviewLabelmaritalStatus: 'Marital status',
    reviewLabeldependants: 'No. of dependants',
    reviewLabeladdresses: 'Address',
    reviewLabelresidentialStatus: 'Residential status',
    reviewLabeldateMoved: 'Date moved',
    reviewLabelPreviousaddresses: 'Previous address',

    reviewLabelsectionContactDetails: 'Contact details',

    reviewLabelemailAddress: 'Email address',
    reviewLabelpreferredContactMethod: 'Preferred contact method',
    reviewLabelphoneNumber: 'Phone number',

    reviewLabelsectionNationality: 'Nationality',

    reviewLabelnationality: 'Nationality',
    reviewLabelcountryBorn: 'Country of birth',
    reviewLabelcityBorn: 'City of birth',
    reviewLabelukCitizen: 'UK citizen',
    reviewLabelcitizenshipList: 'Additional citizenships',
    reviewLabeltaxObligations: 'Additional tax obligations',
    reviewLabelallTaxObligationsListed: 'All tax obligations listed',

    reviewLabelsectionEmployment: 'Employment details',

    reviewLabelemploymentStatus: 'Employment status',
    reviewLabelemploymentOccupation: 'Occupation',
    reviewLabelemployerName: 'Employer name',
    reviewLabelemploymentStartDate: 'Start date',

    reviewLabelsectionIncome: 'Income',

    reviewLabelgrossAnnualIncome: 'Gross annual income',
    reviewLabelnetMonthlyIncome: 'Net monthly income',
    reviewLabelincomeOtherAmount: 'Additional income',
    reviewLabelincomeOtherFrequencyOptions: 'Frequency',

    reviewLabelsectionCA: 'Current account',

    reviewLabelincomeOtherAccountPurpose: 'Account purpose',
    reviewLabelincomeOtherPaymentTypeOptions: 'Account use for',
    reviewLabelincomeOtherPaymentAmount: 'Monthly pay in',

    reviewLabelsectionSA: 'Savings account',

    reviewLabelincomeOtherSavingsAmount: 'Pay in amount',
    reviewLabelincomeOtherSavingsFrequency: 'Frequency',

    reviewLabelsectionOutgoings: 'Outgoings',

    reviewLabelmortgageOrRentExpenditure: 'Mortgage / rent',
    reviewLabelexpenditureOther: 'Other',

    // DGS Documents
    reviewAcceptSaDgs:
      'Yes, I agree to the Savings Account Deposit Guarantee Scheme',
    reviewAcceptCaDgs:
      'Yes, I agree to the Current Account Deposit Guarantee Scheme',
    DGSDocLink: 'static/CYB00174_FSCS Information Sheet _079601_v10.pdf',
    DGSDocLinkTitle:
      'Download Deposit Guarantee Scheme information sheet PDF. This link will open in a new browser window.',
    DGSDocName: 'Deposit Guarantee Scheme information sheet',
    DGSDocFileName: 'CYB00174_FSCS information sheet _079601_v10.pdf',
    DGSDocVersion: '10.0',

    // Marketing Prefs
    marketingPrefsTitle: 'Marketing stuff',
    marketingPrefsText:
      "When we have new stuff we think you'd find useful, we'd like to tell you about it. If that's okay with you, let us know the best way to do that here. We should say, whatever you choose will replace anything you've already told us about this (so if you've said phone before but say email now).",
    marketingPrefsSmsDYB: '',

    // Offer Page
    offerItemCurrentAndSavingsAccounts:
      'Both a Virgin Money Current Account and a Virgin Money Instant Savings account.',
    offerItemSelfService: 'Access to our app',
    offerItemWithInterest:
      'Ongoing 2% AER (variable) interest on balances up to £3000',
    offerItemDebitContactless:
      'A Debit Mastercard for your Virgin Money Current Account with contactless functionality as well as allowing you to withdraw cash at any UK ATM, subject to available funds. We will tell you your daily withdrawal limit when we send you your Virgin Money debit card.',
    offerItemDebitContactlessLimited:
      'A Debit Mastercard Online Only card for your Virgin Money Current Account with contactless functionality allowing you to withdraw up to £350 a day at any UK ATM, subject to available funds.',

    offerItemCaControl:
      'A Debit Mastercard Online Only card with contactless functionality allowing you to withdraw up to £350 a day at any UK ATM, subject to available funds.',
    // ready cash offers
    offerItemReadyCash:
      'A Debit MasterCard Online Only card without contactless functionality allowing you to withdraw up to £350 a day at any UK ATM, subject to available funds.',
    offerItemNoFees: 'There are no fees or charges for this account.',
    offerItemNoCreditInterest: "This account doesn't pay credit interest.",
    offerItemNoOverdrafts: 'Overdrafts are not permitted.',
    offerItemNoBorrowing:
      'Borrowing is not available on this account. Requests for unplanned borrowing will usually be declined. {termsAndConditionsDoc}',
    offerItemDebitCard:
      'You will receive a Debit Mastercard Online Only card with non contactless functionality allowing you to withdraw up to £350 a day at any Clydesdale ATM or UK ATM, subject to available funds.',
    offerItemDeposits:
      'Your eligible deposits with Virgin Money PLC are protected up to a total of £85,000 by the Financial Services Compensation Scheme, the UK’s deposit guarantee scheme. This limit is applied to the total of any deposits you have with Virgin Money PLC brands, including Clydesdale Bank, Yorkshire Bank and B. Any total deposits you hold above the limit between these brands are unlikely to be covered. Please see <a href="http://www.cbonline.co.uk/resources/b82e172a-b00f-4783-973b-e4399da349e4/fscs_2015_online-leaflet.pdf" target="_blank" title="www.fscs.org.uk. This link will open in a new browser window">FSCS leaflet<span class="screenreader"> This link will open in a new browser window</span></a> for further information or visit <a href="http://www.fscs.org.uk" target="_blank" title="www.fscs.org.uk. This link will open in a new browser window">www.fscs.org.uk<span class="screenreader"> This link will open in a new browser window</span></a>',
    offerItemCancelation:
      'You can cancel your agreement with us within 14 days of opening the account, or from the day you receive the terms and conditions, if later, by contacting us in branch, by phone or in writing. You will need to repay any debit balance, interest and fees incurred within 30 days of the date you tell us you want to cancel it.',

    offerItemCaDirectCaPlus:
      'A Debit Mastercard with contactless functionality as well as allowing you to withdraw cash at any UK ATM, subject to available funds. We will tell you your daily withdrawal limit when we send you your Debit MasterCard.',

    offerPageUnsuccessfulTitle:
      'We are sorry, it appears that you are not eligible for the {productTitle} as you don’t hold the appropriate current account',
    offerPageDowngradeTitle:
      'Unfortunately you have been unsuccessful for the {productTitle}',
    offerPageAlternativeOfferTitle: 'However we can offer you our ',
    offerPageHeader: 'Offer',
    offerPageTitle: 'Happy days. You can open this account.',
    offerPageAltTitle: 'We are pleased to offer you a ',
    offerPageSubTitle: 'This offer includes:',
    offerPageIntroTitle:
      'This section contains certain key information relating to the Readycash account. Full details are contained in your terms and conditions and in your tariff which you should read.',

    offerPageKeyFeaturesTitle: 'Key features for',
    offerPageofferRestrictionsTitle: "This offer doesn't include:",
    offerPageDocumentToReadSectionTitle: 'Documents for you to read and save:',
    offerPageDeclineOffer:
      "If there's something you're undecided about, please call us on " +
      brand.phoneNumber +
      ' or go into a branch.',
    offerConditionsIntro:
      'You will receive these by email after you have opened the account.',
    offerTandCQuestion:
      'By ticking this box and clicking "Yes, open my account" this represents my signature confirming that:',
    offerPageContinue: 'Do you wish to continue with the offer of a ',
    openAccountButton: 'Yes, open my account',
    declineAccountButton: 'No, do not proceed',
    downgradedOfferPageEmail:
      'We will also email you these four documents after you have opened the account',

    // Offer Page Mandate
    mandateTitle: '',
    mandateParagraph:
      "By clicking the 'Yes, open my account' button, this confirms my signature and authority, and that I am opening an account.",

    // Savings Account Information
    savingsAccountInformation1:
      'For more information regarding the savings account, please see the terms and conditions',

    // Mutli Offer & Modal
    altOpenAccountButton: 'Accept offer',
    altDeclineAccountButton: 'Decline offer',
    offerCancelApplicationBtn: 'Cancel application',
    offerCancelApplicationModalTitle:
      'Are you sure you want to cancel this application?',
    offerCancelApplicationConfirm: 'Yes',
    offerCancelApplicationDecline: 'No',
    offerCancelIntro:
      'If you do not wish to proceed with your application you can cancel below',

    // Mandate items
    mandateBullet1:
      'I wish to apply for these Virgin Money accounts and Virgin Money app',
    mandateBullet2:
      'I have read and accept the terms and conditions and tariff for these Virgin Money accounts and Virgin Money App. And I have also saved or printed a copy of the terms and conditions and tariff',
    mandateBullet3:
      'I acknowledge receipt of the Financial Services Compensation Scheme information sheet for both Virgin Money Current Account and Virgin Money Instant Savings account',
    mandateBullet4:
      'I authorise you to undertake any necessary searches and credit checks required to validate my identity and address, and',
    mandateBullet5:
      'If my application is accepted and I proceed to open these Virgin Money accounts, I authorise you to debit to the accounts all cheques, orders, payments and withdrawals signed or otherwise authorised by me. I also authorise you to debit to the Virgin Money Current Account all transactions made by using any debit cards that you may issue to me',
    mandateBullet6: undefined,
    mandateBullet7: undefined,
    mandateBullet8: undefined,
    mandateBullet9: 'I wish to apply for the account',
    mandateBullet10:
      'I have read and accept the terms and conditions and tariff. And I have also saved or printed a copy of the terms and conditions and tariff',
    mandateBullet11:
      'I acknowledge receipt of the Financial Services Compensation Scheme information sheet',
    mandateBullet12:
      'I authorise you to undertake any necessary searches and credit checks required to validate my identity and address, and',
    mandateBullet13:
      'If my application is accepted and I proceed to open the account, I authorise you to debit to the account all cheques, orders, payments and withdrawals signed or otherwise authorised by me. I also authorise you to debit to the account all transactions made by using any debit cards that you may issue to me',

    // Deferred Page
    deferredPageHeader: 'Deferred',
    deferredPageTitle: 'We need more time to look at your application.',
    deferredPageExplanation:
      'A team member needs to go over your application in more detail. We will do this within two working days and you will be notified by email or text with a link to log in and see the decision.',

    // ID Deferred Page
    idDeferredPageHeader: 'Verify your identity',
    idDeferredPageTitle: 'We need to see your ID in person',
    idDeferredPageExplanation:
      'We have been unable to verify your identity. You will need to pop into a branch to apply for your account.',
    idDeferredPageNextStepsItems: ['Passport', 'Driving license'],
    idDeferredLinkTitle:
      'Download ID requirements factsheet PDF. This link will open in a new browser window.',
    idDeferredLinkText:
      'For details on what ID to bring with you please click here. Cheers.',
    idDeferredLinkUrl:
      'http://www.cbonline.co.uk/wcm-media/CYB-Identificatio-Requirements.pdf',

    // Contact Bank Page
    contactBankPageHeader: 'We need your number',
    contactBankPageTitle: 'We need your number',
    contactBankPageExplanation:
      'To continue your application we need you to update your mobile details. Please give us a call on ' +
      brand.phoneNumber +
      '.',

    // Account Locked Page
    accountLockedPageHeader: 'Account locked',
    accountLockedPageExplanation1:
      "Sorry. We've had to lock your account to ensure it's kept secure.",
    accountLockedPageExplanation2:
      'You can unlock your account by resetting your password.',
    accountLockedPageExplanation3:
      'Alternatively, you can contact support on <strong>' +
      brand.phoneNumber +
      '</strong>.',
    accountLockedPageExplanation4:
      'Please quote your ID: <strong>{quote_id}</strong>',
    accountLockedPageResetPasswordButtonLabel: 'Reset your password',

    // Session Timeout Text
    sessionTimeout: 'Your session has timed out.',

    // Sorry Page
    sorryPageHeader: 'Sorry',
    sorryPageTitle: "Sorry, we can't offer you these Virgin Money accounts.",
    sorryPageExplanation1:
      "Thank you for applying. I'm sorry, but based on our own credit scoring system, and information from outside credit reference agencies - Experian and Callcredit - we're unable to offer you this account at the moment. We will send you a letter in the post to confirm this decision. You can request a copy of your report from the credit reference agencies by clicking on the links below. Just bear in mind that they may charge you a fee for this.",
    sorryPageExplanation2: '{findOutMore}',
    sorryPageExplanation3DYB:
      'If you think there are special circumstances related to your application, you can call us to discuss it on ' +
      brand.phoneNumber +
      '. Lines are open Monday to Friday 8am to 8pm, closed on Saturday and Sunday.',
    sorryFindOutMore: '',
    sorryPageFormLink:
      'http://www.experian.co.uk/consumer/statutory-report.html',
    sorryPageFormLink2: 'http://www.callcredit.co.uk',
    sorryPageFormLinkText: 'Click here to visit Experian website',
    sorryPageFormLinkText2: 'Click here to visit Callcredit website',
    sorryPageFormLinkTitle: 'This link will open in a new window',
    sorryPageFormLinkTitle2: 'This link will open in a new window',

    // Decline Page
    declinePageTitle:
      'We are sorry but after careful consideration we declined your application for {}. We note you did not proceed with our offer of an alternative product.',
    declinePageParagraph1:
      'We use a Credit Scoring System and information from credit reference agencies, Experian and Callcredit, to ensure we assess all credit applications fairly and consistently. You can request a copy of your report from the credit reference agencies by clicking on the link below.',
    declinePageParagraph2:
      'If you think there are special circumstances related to your application, you can call us to discuss it on ' +
      brand.phoneNumber +
      '. Lines are open Monday to Friday 8am to 8pm, closed on Saturday and Sunday. We will send you a letter in the post to confirm this decision.',
    declinePageLink1:
      '<a href="http://www.experian.co.uk/consumer/statutory-report.html" target="_blank" title="www.experian.co.uk/consumer/statutory-report.html This link will open in a new browser window">Click here to visit Experian website <span class="screenreader"> This link will open in a new browser window.</span></a>',
    declinePageLink2:
      '<a href="http://www.callcredit.co.uk" target="_blank" title="www.callcredit.co.uk This link will open in a new browser window">Click here to visit Callcredit website <span class="screenreader"> This link will open in a new browser window.</span></a>',

    // Registration Page
    registrationPageHeader: 'Registration',
    registrationPageTitle: 'Congratulations',
    registrationPageSubTitle:
      "You'll be needing these account details. Got a pencil?",
    registrationPageParagraph1:
      "To give you a backup in case you ever lose your phone or tablet, we recommend you register for internet and telephone banking now. You'll need your customer number (up there) and the password you created at the start of this form. You should also definitely write down/ copy and paste/ screenshot your customer number now as you'll need it to download the app",
    registrationPageParagraph2:
      "You'll also need a telephone access code. (That bit comes later.)",
    registrationPageBulletParagraph:
      "For internet banking you'll need the following details to log in:",
    registrationPageBullet1: undefined,
    registrationPageBullet2: undefined,
    registrationPageBullet3: 'Set up internet banking',
    registrationPageErrorMessage:
      'There has been a problem registering your {0} credentials. The reason is {1}.',
    // Alternative YB/CB rgistration content
    registrationPageHeaderCYB: 'Registration',
    registrationPageTitleCYB: 'Congratulations, your account has been opened',
    registrationPageSubTitleCYB:
      "Your account details and information you'll need to make a note of",
    registrationPageParagraph1CYB:
      "Now that your account is opened, let's register you for Internet and Telephone Banking services so that you can use your account straight away.",
    registrationPageParagraph2CYB:
      "For telephone banking you'll need your customer number – again it's above, and your telephone PIN – which you can set up below.",
    registrationPageBulletParagraphCYB:
      "For internet banking you'll need the following details to log in:",
    registrationPageBullet1CYB: 'your customer number - which is above',
    registrationPageBullet2CYB:
      'your password - which you created at the start of this application',
    registrationPageBullet3CYB:
      'your security questions for Internet Banking - which you can set up below',
    registrationPageErrorMessageCYB:
      'There has been a problem registering your {0} credentials. The reason is {1}.',

    securityQuestionsTitle: 'Set up your internet banking',
    securityQuestionsSubTitle:
      'Please choose some security questions and answers. These will be used when you log in to internet banking.',

    securityPageLoadingMessage: 'Loading...',
    securityPageSubmissionMessage: 'Submitting answers...',

    securityQuestionDropdownValidationMessage:
      "Sorry, you can't select the same question twice.",
    securityQuestionInputValidationMessage:
      'Your answer must be 6-20 characters long, and only contain letters and numbers.',
    securityQuestionDropdownHelpText:
      'These questions are a safeguard against the risk of fraud and make your log in to internet banking more secure.',
    securityQuestionInputHelpText:
      'Type in a simple answer that you can easily remember for each question. Your answer must be 6-20 characters long, and only contain letters and numbers.',
    telephonePinTitle: 'Telephone banking',
    telephonePinHelpMessage:
      "Your telephone access code is a special code you'll use to identify yourself when you phone up to use telephone banking. It's an important security measure. It needs to be a 4 digit number which you can easily remember. Don't use the same number more than three times, or have any sequential numbers in there like 1234.",
    telephonePinValidationMessage:
      'Pick a 4-digit number, with no consecutive numbers, and without using the same number four times.',
    telephonePin2HelpMessage:
      'This needs to be exactly the same as the PIN entered in the box above.',
    telephonePin2ValidationMessage: "Try again? The PIN numbers didn't match.",
    registrationTCsTitle:
      'Download and save the terms and conditions for telephone and internet banking for your records. These will also be emailed to you.',
    registrationTsAndCsDocLink: 'static/rib-tb-terms.pdf',
    registrationTsAndCsDocVersion: '0815',
    registrationTsAndCsText:
      'Terms and conditions for telephone and internet banking',
    registrationTsAndCsDocLinkTitle:
      'Download terms and conditions for telephone and internet banking PDF. This link will open in a new browser window.',
    registrationAcceptTCs:
      'I confirm by ticking this box that I agree to the terms and conditions above.',
    registrationAcceptTCsValidationMessage:
      'You need to agree in order to carry on.',

    alreadyRibRegistered:
      "It looks like you're already signed up for internet banking, you don't need to do anything more here.",
    alreadyTBRegistered:
      "It looks like you're already signed up for telephone banking, you don't need to do anything more here.",

    // Submission Page
    submissionPageHeader: 'Submission',
    submissionPageTitle: 'Thank you for sending your application',
    submissionPageText: 'Please wait while your details are checked',

    // Security Page
    securityPageTitle: 'Nearly there',
    timerSectionTitle: 'Just tell us a bit more about yourself',
    timerSectionTimeUnitDescription: 'mins',
    timerSectionTimeUnitExpiredDescription:
      "Sorry, but you've run out of time.",

    // Account Opened Page
    accountOpenedPageHeader: 'Account opened',
    accountOpenedPageTitle: "You're good to go",
    accountOpenedAppDownloadTitle: 'Now you can download our Virgin Money app',

    accountOpenedSection1Title: "What's next?",
    accountOpenedSection1Bullet1:
      "Within the next few days, we will email you with important T&Cs, Tariffs and other documents to read and save. If you can't see their message, please check your junk and spam just in case it's landed there.",
    accountOpenedSection1Bullet2:
      'You’re all registered for internet banking too. You can use this straight away by going to the login button at the top right of any page on <a href="' +
      brands.CB.bankWebsite +
      '" target="_blank" title="www.cbonline.co.uk. This link will open in a new browser window">www.cbonline.co.uk<span class="screenreader"> This link will open in a new browser window</span></a> or <a href="' +
      brands.YB.bankWebsite +
      '" target="_blank" title="www.ybonline.co.uk. This link will open in a new browser window">www.ybonline.co.uk<span class="screenreader"> This link will open in a new browser window</span></a>. You\'ll need your customer number, password and security details.',
    accountOpenedSection2Title: 'Look out for the post too:',
    accountOpenedSection2Bullet1:
      'Your Virgin Money Debit Mastercard and PIN will arrive separately in around 3-5 days.',
    accountOpenedSection2Bullet2:
      "If you'd like a cheque book as well please call us on " +
      brand.phoneNumber,
    accountOpenedSection3Title: 'With Virgin Money, you can also:',
    accountOpenedSection3Bullet1:
      'Arrange to include your Virgin Money accounts in mortgage offsetting arrangements (this won’t be done automatically)',
    accountOpenedSection3Bullet2:
      'Apply for an overdraft (subject to eligibility)',
    accountOpenedSection3Bullet3:
      'Apply for a credit card or a personal loan (subject to eligibility)',
    accountOpenedSection3Bullet4:
      'For any of these, please get in touch with us on ' + brand.phoneNumber,
    accountOpenedSection4Title: 'P.S. Here are some useful links:',
    accountOpenedSection4Bullet1:
      'Any questions? Find out the answers <a href="https://www.youandb.co.uk/faq/tablet" target="_blank" title="Tablet FAQs. This link will open in a new browser window">here<span class="screenreader"> This link will open in a new browser window</span></a>',
    accountOpenedSection4Bullet2: '',
    accountOpenedSection5Title: '',
    accountOpenedSection5Bullet1: '',
    // Alt CYB content for account opened
    accountOpenedPageTitleCYB: "Good news, you're all done",
    accountOpenedSection1TitleCYB: 'Check your email',
    accountOpenedSection1Bullet1CYB:
      "In the next few days we will send you an email with important information for you to read and save. Check your email filters in case it's gone straight to your junk/spam folder and you can't see it in your inbox",
    accountOpenedSection1Bullet2CYB:
      'You’re all registered for internet banking too. You can use this straight away by going to the login button at the top right of any page on <a href="' +
      brands.CB.bankWebsite +
      '" target="_blank" title="www.cbonline.co.uk This link will open in a new browser window">www.cbonline.co.uk <span class="screenreader">This link will open in a new browser window</span></a> or <a href="' +
      brands.YB.bankWebsite +
      '" target="_blank" title="www.ybonline.co.uk This link will open in a new browser window">www.ybonline.co.uk <span class="screenreader">This link will open in a new browser window</span></a>. You\'ll need your customer number, password and security details.',
    accountOpenedSection2TitleCYB: 'Look out for your post',
    accountOpenedSection2Bullet1CYB:
      'You will receive a welcome letter which will confirm the details of your new account, please read through and send us back your specimen signature, as we’ll need this so you can make certain transactions on your account',
    accountOpenedSection2Bullet2CYB:
      'Your Debit Mastercard and PIN are on their way. These will come separately and will be with you within 3-5 working days',
    accountOpenedSection3TitleCYB: 'Useful links',
    accountOpenedSection3Bullet1CYB:
      'Download our mobile banking app <a href="' +
      brand.monetiseLink +
      '" target="_blank" title="Click here to download our mobile banking app. This link will open in a new browser window">here <span class="screenreader">Click here to download our mobile banking app. This link will open in a new browser window</span></a>',
    accountOpenedSection3Bullet2CYB:
      '<a href="' +
      brand.faqsLink +
      '" target="_blank" title="FAQs. This link will open in a new browser window">FAQs <span class="screenreader">This link will open in a new browser window</span></a> to help answer any queries you may have',
    accountOpenedSection3Bullet3CYB: '',
    accountOpenedSection4TitleCYB: 'Contact us',
    accountOpenedSection4Bullet1CYB:
      'If you have any queries about your new account',
    accountOpenedSection5TitleCYB: 'Ways to contact us',
    accountOpenedSection5Bullet1CYB:
      'Call us on ' + brands.YB.phoneNumber + ' or pop in to your local branch',

    // Portal Page
    portalPageHeader: 'Portal',
    portalPageTitle: 'Your saved applications',
    portalPageSubTitle: 'Pick an application to carry on with',

    // Login Page
    loginPageHeader: 'Login',
    loginPageTitle: 'Your saved application',
    loginPageNextButtonLabel: 'Please log in to carry on',
    usernameLabel: 'Customer number/Username',
    usernameValidationMessage:
      "Here you can use either your customer number or Username. Your customer number is 10 numbers long, detailed in your internet banking welcome letter. Your username is 6-16 characters long, and can be letters and numbers. It's also case sensitive.",
    usernameHelpMessage:
      'This is your customer number or username you created when you registered to save your application earlier on. Please call us if you need help.',
    passwordLabel:
      "Please type the characters we've requested from your internet banking password. The password characters are case sensitive.",
    passwordValidationMessage:
      "Type the characters we've requested from your password.",
    passwordHelpMessage:
      'This is the password you created when you registered for internet banking earlier. Please call us if you need help.',
    passwordCharacterPrefix: 'Character ',
    goneWrongMessage:
      'Can you check your details and try again please? Something went wrong but it might work if you try again.',
    tooManyRetries:
      'You have exceeded the maximum number of login attempts. Please try again later.',
    cannotBeLoggedIn:
      'Sorry we cannot log you in at this time. Please contact us for support.',

    OTP: {
      pageHeading: 'Nearly there. Just need to be secure.',
      body: 'Pop in the 6-digit passcode that’s just been sent to {number}',
      validationError:
        'That’s not the right code. Try again or request a new code',
      resendPasscode: 'Resend passcode',
      passcodeOnWay: 'Your passcode is on its way',
      gotIt: 'Ok, got it',
      resendDetails:
        'This could take a few minutes to reach you depending on your network provider.',
    },

    // Switch Page
    switchPageHeader: 'Switch',
    switchPageTitle:
      "Switch to Virgin Money. It's easy and there's a guarantee",
    switchPageHeadingOptional1:
      "The switch guarantee means it's really straightforward",
    switchPageText1:
      "First of all, we will do everything for you, you won't even have to get in touch with your old bank.",
    switchPageHeadingOptional2: 'Make sure you arrange an overdraft first',
    switchPageText2:
      "If you have an overdraft on your old account, you'll need to contact us before you switch on " +
      brand.phoneNumber +
      " to make sure you get one with us. If you're eligible and you're using your overdraft at the moment, your balance will be carried across, even if it's in debit, subject to checks of course. If you prefer speaking to someone in person, you can also pop into branch. Staff will be more than happy to help.",
    switchPageHeadingOptional3: '',
    switchPageText3: '',
    switchPageHeadingOptional4: 'A word in your ear',
    switchPageText4:
      "Once switching has started it can't be stopped, but the guarantee means that if anything goes wrong, tell us and you'll get a refund of any interest or charges made on either your old account or the new one as a result. If, for any reason, you don't qualify for the Current Account Switch Service, or you don't want to use it, you can use the Payment Transfer Service. This enables you to transfer all your Direct Debits and standing orders from your old account over 3 months. Please note that the 7 working day switch guarantee does not apply to this service.",
    switchPageText5: '',
    switchPageText6: '',

    wantsToSwitch: 'Want to switch from your current account to Virgin Money?',
    wantsToSwitchValidationMessage: 'This is required.',
    switchDetailsTitle: 'Your old current account details',
    switchAccountNameValidationMessage:
      'Your account name must be no more than 18 characters long.',
    switchAccountNameHelpMessage:
      'This is the name shown on your account statement.',
    switchAccountNumberValidationMessage: 'This must be 8 numbers long.',
    switchAccountNumberHelpMessage:
      'The account number will appear on your account statements.',
    switchSortCodeValidationMessage: 'This is 6 numbers long.',
    switchSortCodeHelpMessage:
      'You will see your sort code on your account statements, usually next to the account number.',
    switchHasDebitCardValidationMessage: 'Your 16-digit card number',
    switchDebitCardPanLabel: 'Your 16-digit card number',
    switchDebitCardPanValidationMessage: 'Your 16-digit card number',
    switchDebitCardPanHelpMessage:
      'This is the main number across the front of the card, typically printed in bigger characters and usually 16 numbers long.',
    switchDebitCardExpirationValidationMessage:
      'Please use numbers without any extra characters, so for example January 2017 should be written like this: 0117. The card must not have expired.',
    switchDebitCardExpirationHelpMessage:
      "This will be shown on the card as a month and year, typically next to a statement such as 'Expires end'.",
    switchTypeValidationMessage: 'This is required.',
    switchTypeTitle: 'Choose from two types of switch',
    switchTypeFullSwitch:
      'A full switch using the Current Account Switch Service will guarantee that once you have chosen and agreed the switch date with us the full balance and regular payments associated with your old account at your old bank will be switched to your new account and your old account will be closed. You will be advised of regular payments that cannot be automatically transferred and any payments made to your old account will be redirected to your new account.',
    switchTypePaymentSwitch:
      'The Payment Transfer Service allows you to choose which payments you would like to transfer across to your new account and your old account will not be closed. Please note that the 7 working day switch guarantee does not apply to this service.',
    switchDateValidationMessage:
      'The date cannot be in the past. Please remeber to select a date at least 7 working days from now, which is not a weekend or Bank Holiday.',
    switchDateHelpMessage:
      'This is the date you would like the switch to take place.',
    switchDateGuidance:
      'Please select a date at least 7 working days from now, which is not a weekend or bank holiday.',
    switchCloseOldAccount:
      'Yes, I agree to you closing my old current account when the switch to my new one is complete.',
    switchCloseOldAccountValidationMessage:
      'Please confirm your consent to continue.',
    switchCloseOldAccountHelpMessage:
      "This means that we'll transfer your balance, direct debits and standing orders before closing the account.",
    switchFullTsAndCsDocLink: 'static/switch-terms-' + brand.bankCode + '.pdf',
    switchFullTsAndCsDocLinkTitle:
      'Download Current Account Switch Service terms and conditions PDF. This link will open in a new browser window.',
    switchFullTsAndCsDocVersion: '1.0',
    switchFullTsAndCsText:
      'Current Account Switch Service terms and conditions',
    switchAcceptFullTCs: 'Yes, I agree to the terms and conditions above',
    switchAcceptFullTCsValidationMessage: 'Please agree in order to continue.',
    switchPaymentsTsAndCsDocLink:
      'static/payment-transfer-' + brand.bankCode + '.pdf',
    switchPaymentsTsAndCsDocLinkTitle:
      'Download Payment Transfer Service Tterms and conditions PDF. This link will open in a new browser window.',
    switchPaymentsTsAndCsDocVersion: '1.0',
    switchPaymentsTsAndCsText: 'Payment Transfer Service terms and conditions',
    switchAcceptPaymentsTCs: 'Yes, I agree to the terms and conditions above',
    switchAcceptPaymentsTCsValidationMessage:
      'Please agree in order to continue.',
    // Switch page alt CYB content
    switchPageHeaderCYB: 'Switch',
    switchPageTitleCYB: 'Switch to us with the Current Account Switch Service',
    switchPageText1CYB:
      'If you have an agreed overdraft facility on your old account you will need to arrange a planned borrowing limit with us prior to switching your account to ensure that you can fully transfer any debit balance as part of your switch. You can arrange planned borrowing, subject to eligibility, just pop into your nearest branch or call us on 0800 678 3350.',
    switchPageText2CYB:
      "Switching your current account to us from another bank is straightforward with the Current Account Switch Service, we'll do everything for you. We'll contact your old bank so you don't have to worry about letting them know. The Current Account Switch Service is free to use and once you have chosen and agreed your switch date with us, we guarantee it will only take 7 working days, backed by the Current Account Switch Guarantee. On your switch date, your old account will be closed and all your payments and credit balance will be transferred to your new {bankName} account.",
    switchPageText3CYB:
      '<strong>Once your switch has started it cannot be stopped</strong>, but the guarantee means that if anything goes wrong we’ll refund any interest or charges made on either your old account or the new one as a result.',
    switchPageText4CYB:
      "If you're not eligible for the Current Account Switch Service, or you don't want to use it, the Payment Transfer Service lets you transfer your Direct Debits and standing orders from your old account to your new account over a 3 month period.",

    wantsToSwitchCYB:
      "If you want to use either of these switching services, please click on the 'Yes' button.",
    wantsToSwitchValidationMessageCYB: 'This is required.',
    switchDetailsTitleCYB:
      'Please fill in the following details. Use the details from the old account you’re switching from, and not the new one you’ve just opened.',
    switchAccountNameValidationMessageCYB:
      'Your account name must be no more than 18 characters long.',
    switchAccountNameHelpMessageCYB:
      'This is the name shown on your account statement.',
    switchAccountNumberValidationMessageCYB: 'This must be 8 numbers long.',
    switchAccountNumberHelpMessageCYB:
      'The account number will appear on your account statements.',
    switchSortCodeValidationMessageCYB: 'This is 6 numbers long.',
    switchSortCodeHelpMessageCYB:
      'You will see your sort code on your account statements, usually next to the account number.',
    switchHasDebitCardValidationMessageCYB: 'This is required.',
    switchDebitCardPanLabelCYB: 'Your 16-digit card number',
    switchDebitCardPanValidationMessageCYB:
      'This is the long number on the front of the card.',
    switchDebitCardPanHelpMessageCYB:
      'This is the main number across the front of the card, typically printed in bigger characters and usually 16-19 numbers long.',
    switchDebitCardExpirationValidationMessageCYB:
      'Please use numbers without any extra characters, so for example January 2017 should be written like this: 0117. The card must not have expired.',
    switchDebitCardExpirationHelpMessageCYB:
      "This will be shown on the card as a month and year, typically next to a statement such as 'Expires end'.",
    switchTypeValidationMessageCYB: 'This is required.',
    switchTypeTitleCYB: 'Please choose a switch option.',
    switchTypeFullSwitchCYB:
      'A full switch using the Current Account Switch Service will guarantee that once you have chosen and agreed the switch date with us that the full balance and regular payments associated with your old account will be switched to your new account and your old account will be closed. You will be advised of regular payments that cannot be automatically transferred and any payments made to your old account will be redirected to your new account.',
    switchTypePaymentSwitchCYB:
      'The Payment Transfer Service allows you to choose which payments you would like to transfer across to your new account, your old account will not be closed.',

    // Map Switch Response Codes to Messages
    switchCode000: 'Your switch has been successful',
    switchCode340:
      "Sorry. This account doesn't allow switching. But you can transfer your details from your old bank to Virgin Money. Please call us on " +
      brand.phoneNumber +
      ' for help.',
    switchCode365:
      "Sorry. This account doesn't allow switching. Please call us on " +
      brand.phoneNumber +
      ' for help.',
    switchCode366:
      'The sort code, account number or 16-digit card number you’ve entered aren’t quite right. Please give them a double-check and try again.',
    switchCode364:
      "Sorry. You can't switch to this account at the moment. Please get in touch with us.",
    switchCode367:
      "Sorry. You can't carry out a switch to Virgin Money on this account.",
    switchCode345:
      "Switches can't go ahead on weekends and bank holidays. Please choose another date for your switch.",
    switchCode346:
      "Please pick a switch date that's at least 7 working days from now.",
    switchCode347:
      "Please pick a switch date that's less than 90 days from today, and more than 7 working days in the future.",
    switchCode393:
      'There’s been a problem, please try again later or call the team on ' +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode394:
      "Sorry. You can't switch to this account at the moment. Please get in touch with us.",
    switchCode395:
      "There's been a problem, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode349:
      "There's been a problem, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode350:
      "Please check that the day, month and year you've given for your date of birth are correct. If they are then please get in touch with us.",
    switchCode353:
      "Please pick a switch date that's at least 7 working days in the future.",
    switchCode380:
      "Sorry. You can't switch to Virgin Money from this type of account. Please call us on " +
      brand.phoneNumber +
      ' for help.',
    switchCode402:
      "Sorry. You can't switch to Virgin Money from this type of account. Please call us on " +
      brand.phoneNumber +
      ' for help.',
    switchCode403:
      "Sorry. You can't switch to Virgin Money from this type of account. To switch you need an account that's backed by the Current Account Switch Service. Please call us on " +
      brand.phoneNumber +
      ' to get something sorted.',
    switchCode398:
      "There's been a problem, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode801:
      "There's been a problem, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode355:
      "There's been a problem, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode358:
      "There's been a problem, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode359:
      "There's been a problem, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode348:
      "Hold your horses - there's already a switch going on for this account.",
    switchCode861:
      "There's been a problem, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode362:
      "There's been a problem, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode363:
      "There's been a problem, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode389:
      'We need your postal address to continue, please call ' +
      brand.phoneNumber +
      '.',
    switchCodeDefault:
      'Sorry, something has gone wrong creating your switch application',

    // Authentication Page
    authPageHeader: 'Application',
    authPageSubtitle: 'Please login to continue',
    authPageTitle: 'Authentication',
    authFormTitle: undefined,
    authFormSubTitle: undefined,
    hasCustomerName: 'Do you have a customer number/username?',
    authChallengeSecurityQuestionValidationMessage:
      'This is the answer to the internet banking security question you selected at the time of registration. Please call us if you need help.',
    authPageContact:
      "If you need help with your application, or if any of your details aren't up-to-date, please call us on " +
      brand.phoneNumber +
      '.',

    authBankQuestion: 'Please let us know where you have an account',
    authBankIdHelpMessage:
      'Please indicate the bank with which you hold an account',
    authFirstNameQuestion: 'First name',
    authFirstNameHelpMessage:
      'Just using letters and spaces as it appears on your passport or driving licence.',
    authLastNameQuestion: 'Last name',
    authLastNameHelpMessage:
      'Please use your last name as it appears in your passport or driving licence.',
    authGenderQuestion: 'Gender',
    authGenderHelpMessage: 'This is just to help identify you.',
    authDateOfBirthQuestion: 'Date Of nirth',
    authDateOfBirthHelpMessage:
      'Click on the month/year to start entering your dates. There’s no need to scroll. The date entered should be formatted DD-MM-YYYY.',
    authHouseNumberQuestion: 'House number',
    authHouseNumberHelpMessage:
      'This is the number of your house or apartment.',
    authStreetQuestion: 'Street',
    authStreetHelpMessage:
      'Your street name should be written using number and letters only.',
    authPostcodeQuestion: 'Postcode',
    authPostcodeHelpMessage:
      'You need to supply a valid postcode for any UK address you add. These are normally formatted like this: A12 3BC.',
    authCheckDetailsError:
      'Can you check your details and try again please? Something went wrong but it might work if you try again.',
    authNextButtonText: 'Proceed',
    authFirstNameValidationMessage: 'Please use letters and spaces only.',
    authLastNameValidationMessage: 'Please use letters and spaces only.',
    authDateOfBirthValidationMessage:
      'Please enter a valid date in the following format DD-MM-YYYY.',
    authHouseNumberValidationMessage:
      'Sorry, your house number must be written using numbers and letters only and no longer than 40 characters.',
    authStreetValidationMessage:
      'Your street should be written using numbers and letters only and be no longer than 40 characters.',
    authPostcodeValidationMessage:
      'Please enter a valid postcode.  Postcodes are normally formatted like this - A12 3BC',
    authGenderValidationMessage: 'Please select a gender.',
    authPageLoadingMessage: 'Please wait while we load your details...',

    // Authentication Component
    authChallengeTitle: 'Stepup challenge',
    authChallengeSubtitle: '',
    telephoneAuthAccessCode: 'Telephone access code',
    telephoneAuthAccessCodeValidationMessage:
      'This is the 4-digit number you chose for telephone banking',
    telephoneAuthAccessCodeHelpMessage: 'This is 4 numbers long.',
    telephoneAuthSortCode: 'Sort code',
    telephoneAuthAccountNumber: 'Account number',
    debitCardAuthPan: 'Your 16-digit card number',
    debitCardAuthSortCode: 'Sort code',
    debitCardAuthAccountNumber: 'Account number',
    panHelpMessage:
      'This is the 16-digit card number that runs across the middle of the front of your card.',
    accessCodeHelpMessage:
      'This is your four-digit access account number. It’s set during the registration process to allow you to access telephone banking and internet banking.',
    sortCodeHelpMessage:
      "You'll spot your 6-digit sort code on your bank statements and debit card.",
    accountNumberHelpMessage:
      '8-digit account number appears on your bank statements and debit card.',
    panValidationMessage: 'This is 16 numbers long.',
    accessCodeValidationMessage: 'This is 4 numbers long.',
    sortCodeValidationMessage: 'This is 6 numbers long without spaces.',
    accountNumberValidationMessage: 'This is 8 numbers long.',
    forgotPassword: 'Forgotten your password?',

    // Error Page
    errorPageHeader: 'Error',
    upgradeBrowserMessage:
      '<p class="browsehappy">Sorry, our online application does not support your browser. please <a href="http://browsehappy.com/" target="_blank" title="www.browsehappy.com This link will open in a new browser window.">update your browser <span class="screenreader">www.browsehappy.com This link will open in a new browser window.</span></a> to a newer version or try again with a different browser</p><p>You can close this window to return to the site to see other ways to apply.</p>',
    errorPageTitle: 'Sorry there has been a technical problem',
    errorPageText1: 'Something has gone wrong in the background.',
    errorPageText2:
      "While we're sorting it out, can you please call us instead on " +
      brand.phoneNumber +
      '. Lines are open Monday to Friday, 8am-8pm.',

    transactionsErrorBody:
      "Hmm. Looks like something's gone wrong in the background while loading your transactions. Why not give it another go?",
    transactionsErrorButtonTitle: 'Try again',
    transactionsLookupLimitError:
      'Sorry, we can’t show any more transactions. Try refining your date range.',

    // Setup in Progress Page
    setupInProgressHeader: 'Setup',
    setupInProgressTitle: "Sorry, there's been a slight technical hitch",
    setupInProgressText1:
      'Your account will be open and ready the next working day.',
    setupInProgressText2:
      "We'll let you know as soon as it's available so you can register for online banking, telephone banking and account switching.",
    setupInProgressText3: 'We look forward to being in touch very soon.',

    // Any page
    missingRequiredFields:
      'Please call us on ' +
      brand.phoneNumber +
      ' to add the information below and carry on with your application:',
    datePickerHelpMessageSuffix:
      'Click on the month/year to start entering your dates. There’s no need to scroll. The date entered should be formatted DD-MM-YYYY.',
    newBrowserWindowTitle: 'This link will open in a new browser window.',

    // Talk Panel
    talkLine: 'Call any time, day or night.',

    // Email Panel
    emailLine:
      'Send your feedback, but if you need a response please call instead. (Never email your bank details.)',

    // FAQ Panel
    faqLine: 'Find the answers right here.',

    // Demo Panel
    demoLine: 'See how the app works.',

    // About Virgin Money Panel
    aboutBLine: 'Find out what you can do.',

    // T&C Panel
    tncLine: 'Want to have another look?',

    // feature2
    alertLandingPage: 'Manage your alerts',
    AboutBHead: 'About',
    aboutBAccessibility1: 'You are on',
    aboutBAccessibility2: 'landing page',
    AboutBContent: 'Explore what we can do for you.',
    aboutB: 'About',
    cheers: 'Cheers',
    earnInterest: 'Earn interest',
    earnInterestText: 'Current rates can be found at ',
    earnInterestLink:
      'https://uk.virginmoney.com/current-accounts/pca/rates-fees-charges/',
    earnInterestLinkText:
      'uk.virginmoney.com/current-accounts/pca/rates-fees-charges/',
    earnInterestLinkSME:
      'https://uk.virginmoney.com/business/savings-accounts/compare',
    earnInterestLinkTextSME:
      'uk.virginmoney.com/business/savings-accounts/compare',
    earnInterestData1:
      'If you have any queries please call the Virgin Money team.',
    earnInterestData2:
      '** AER stands for Annual Equivalent Rate and illustrates what the interest rate would be if interest was paid and compounded each year. Gross rate is the interest payable without taking account of any tax payable.',
    getHelp: 'Get help',
    getHelpData:
      'If you need help or are unsure about anything get in touch on',
    trackYourSpending: 'Track your spending',
    trackYourSpendingData:
      "Use Tags to find out how much you're spending, and Budgets to plan your spending from month to month.",
    overdraftText:
      'If you need some extra wiggle room, you can apply for an overdraft. Find all the details at ',
    overdraftLink:
      'https://uk.virginmoney.com/current-accounts/pca/account-features/overdrafts/',
    overdraftLinkText:
      'uk.virginmoney.com/current-accounts/pca/account-features/overdrafts/',
    overdraft: 'Get an overdraft if you need one.',
    overdraftData:
      "If you need some extra wiggle room, you can apply for an overdraft. Just don't forget you'll have to pay <strong>12.50% EAR<sup>††</sup></strong> on this. With our arranged overdraft, you get a £25 buffer and a two day grace period but if you go over these a £6 Monthly Planned Usage Fee will kick in on top of the interest.",
    overdraftData1:
      '<sup>††</sup> EAR mean Effective Annual Rate. This covers the rate and frequency of interest charged and the way it adds up (compounds) each year.',
    useyourtimeline: 'Use your timeline',
    useyourtimelineData:
      "Your timeline brings everything together, so you can easily keep an eye on the money that's coming in and out. And it gives you handy hints and tips the more you use your account.",
    freeAlerts: 'Set up free alerts',
    freeAlertsData:
      "So you always know when your money's running low in time to avoid charges.",
    freeAlertsDataSME:
      'Keep up-to-date with what’s in your accounts with regular alerts.',
    projections: 'Projections',
    projectionsData:
      'Know in advance if your balance is due to run low to help you avoid missing payments.',
    sweeps: 'Sweeps',
    sweepsData:
      'Automatically move money between accounts when your balance reaches a certain amount.',
    createSavingPots: 'Create Savings Pots',
    createSavingPotsData:
      'Ideal if you have a goal in mind – like a holiday, or a new car – Savings Pots make it simple to save for the things you really want and move money around with a few taps.',
    statements: 'Get your statements online',
    statementsData: 'View and download your statements whenever you need them.',
    AboutBButton: 'Cheers',
    AboutBTableHead: 'Representative example',
    AboutBR1C1: 'Rate of interest',
    AboutBR1C2: 'Total amount of credit',
    AboutBR1C3: 'EAR<sup>††</sup>',
    AboutBR2C1: '11.84% per annum (variable)',
    AboutBR2C2: '£1200.00',
    AboutBR2C3: '12.50% variable',

    // Timeline Page
    timelineText: 'Your timeline',
    accountsText: 'Your accounts',
    mobileAccountText: 'Account list',
    mobileTimelineText: 'Timeline',
    accountBalanceUnavailable: 'Balance unavailable',
    accountTapToReload: 'Click to reload',
    accountBalanceCurrent: 'current',
    accountBalanceAvailable: 'available',
    NoSearchResult: 'These are all your account transactions at present',

    // Rename accounts
    renameAccountsLandingPageHeader: 'Rename accounts',
    renameAccountsLandingPageSubHeader:
      'Choose the account you want to give a nickname.',
    renameAccountHeader: 'Rename account',
    renameAccountSubHeader:
      "Give your account a nickname that you'll see on internet banking and our mobile app. Don't worry – it's only you that'll see it and it won't change on things like statements or cheque books.",
    renameAccountSuccess: 'Account name has been updated',
    renameAccountRestore: 'Change back to original account name',
    renameAccountNickname: 'Account nickname',

    // Manage insurance
    manageInsuranceLandingPageHeader: 'Insurance benefits',
    manageInsuranceText1:
      'Your Club M Account is bursting with these insurance benefits as standard:',
    manageInsuranceOption1: 'Worldwide travel insurance',
    manageInsuranceOption2: 'Breakdown cover',
    manageInsuranceOption3: 'Mobile and gadget insurance',
    manageInsuranceMessage:
      'You pay a £14.00 monthly fee for maintaining the Club M Account with insurance benefits.',
    manageInsuranceTurnOffText: 'Turn off your insurance benefits',
    manageInsuranceHelpText1:
      'If you choose to, you can turn off your insurance benefits. When you turn off your benefits you will lose your travel insurance, your breakdown cover, and your mobile and gadget insurance. There is no monthly account maintenance fee while your insurance is off.',
    manageInsuranceHelpText2:
      "To turn off your insurance benefits, tap the button below and complete the form on our website. We'll aim to turn off your insurance benefits in three working days. We'll let you know when it happens.",
    manageInsuranceMessage1:
      "You can turn on your insurance benefits again in the future. You'll need to go through all the benefits and eligibility again.",
    manageInsuranceTurnOffButtonText: 'Turn off insurance',
    manageInsuranceSubText: 'Your insurance benefits are off.',
    manageInsuranceText2:
      'Turn on your insurance benefits and pocket the full package of:',
    manageInsuranceInfoText:
      "When you turn on your benefits you'll pay a £14.00 monthly fee for maintaining the Club M Account with insurance benefits.",
    manageInsuranceTurnOnText: 'Turn on your insurance benefits',
    manageInsuranceHelpText3:
      "Pocket the full package. We'll take you through each insurance again to explain the benefits as well as checking to see if you're eligible. To turn on your insurance benefits simply tap the button below and complete the form on our website.",
    manageInsuranceHelpText4:
      "We'll aim to turn on your insurance benefits in three working days. We'll let you know when your insurance is on.",
    manageInsuranceTurnOnButtonText: 'Turn on insurance',

    // Private Banking & Current Tracker Benefits
    privateBankingPageHeader: 'Private banking benefits',
    currentTrackerPageHeader: 'Current account tracker benefits',
    privateBankingText1:
      'The Virgin Money Private Current Account is bursting with benefits that send you packing.',
    currentTrackerText1:
      'The Virgin Money Current Account Tracker is bursting with benefits.',
    privateBankingText2: 'You get:',
    bankingBenefitOption1:
      'Red-hot interest rates on your current account balance',
    bankingBenefitOption2:
      'A named Private Manager who understands your financial goals and can help with more complex financial needs.',
    bankingBenefitOption3:
      'Support on our financial products including mortgages and savings.',
    bankingBenefitOption4:
      'Invitations to special events, unforgettable experiences and everyday discounts in cities where you live and travel. Courtesy of Priceless.com and Mastercard.',
    bankingBenefitOption5: 'Access to foreign exchange solutions.',
    privateBankingText3:
      'And in addition to the above, you also get access to:',
    bankingBenefitMoreInfo:
      'For more information about these benefits, terms and conditions, click here to read our ',
    bankingBenefitHelpfulGuide: 'helpful guide',
    bankingBenefitMessage:
      'You pay a £15 monthly fee for maintaining your account and the services of a dedicated Private Manager.',
    bankingBenefitContactGuide:
      "Please contact your Private Manager if you'd like to make any changes to your account.",

    // HelpPage
    helpPageTitle: 'HelpPage',
    HelpPageHeading: 'Help',
    helpPageError: 'We were unable to load your help at this time.',
    aboutTitle: 'About',
    financialServices: 'Protecting your money',
    financialServices1: 'Financial Services',
    financialServices2: ' Compensation Scheme',

    // Popup
    PopupHeading: 'Opening in new window',
    HelpModelContent:
      'This link will open in a new window or tab and will take you out of internet banking.<br></br>If you like what you see and don’t come back in 5 minutes, you’ll be automatically logged out.',
    HelpPopupContent1:
      'This link will open in a new window or tab and will take you out of internet banking.',
    HelpPopupContent2:
      'If you don’t come back in 5 minutes, you’ll be automatically logged out.',
    // AnyquestionsURL

    anyQuestionURL:
      'https://help.cybonline.co.uk/system/selfservice.controller?CONFIGURATION=1171&PARTITION_ID=1&CMD=STARTPAGE&USERTYPE=1&isSecure=true&isSecure=true&LANGUAGE=en&COUNTRY=us',
    anyQuestionBusinessURL:
      'https://secure.cbonline.co.uk/help-support/business-internet-banking-help/',

    prefrenceUrl: 'https://www.youandb.co.uk/digital-statements',

    anyQuestionURLForLimits: 'https://www.youandb.co.uk/payment-limits',

    // Talk Popup
    TalkHead: 'Calling the team at Virgin Money',
    TalkData:
      'Call <strong>0800 121 7365</strong> for free any time, day or night - from your landline or your mobile.',
    TalkData1:
      "If you're calling from abroad, call +44 141 221 7300, though local providers may charge you for the call.",
    TalkData3:
      "Call <strong>0800 345 7365</strong> for free any time, day or night - from your landline or your mobile.<p><small>If you're calling from abroad, call +44 141 951 7320, though local providers may charge you for the call.</small></p><p>Currently on a call with one of our advisers?<a>Securely share your screen</a> to get live help.</p>",
    TalkButton: 'Back to help',
    TalkMobileData:
      'Call <a href="tel:0800 121 7365">0800 121 7365</a> for free any time, day or night - from your landline or your mobile.',
    TalkMobileData1:
      'If you\'re calling from abroad, call <a href="tel:+44 141 221 7300">+44 141 221 7300</a>, though local providers may charge you for the call.',
    TalkHeader: 'Talk',

    // Email
    EmailHeader: 'Let us know what you think',
    EmailContent:
      'Something to share? Get in touch by email – just remember never to send your bank details.',
    EmailContent2:
      'Email’s mainly used for feedback, so if you need an answer right away, check out the FAQs or give us a call.',
    EmailFooter: '(Never email your bank details.)',
    EmailHead: 'Email is just for feedback right now',
    HelpEmailHead:
      "If you'd like to email what you think of things so far please do. Your thoughts could help make our service even better. Just remember, never give your bank details by email.",
    EmailBody:
      'If you need a response, check out Any questions? in Help.<br/> Or, give us a call on 0800 121 7365.',
    EmailButton1: 'Go back to Help',
    EmailButton2: 'Give feedback',
    FeedbackEmail: 'hello@virginmoney.com',
    EmailSubjectLine: 'My feedback',
    EmailBody1:
      'If you need a response, check out \'Any questions?\' in Help.<br/> Or, give us a call on  <a href="tel:0800 121 7365">0800 121 7365</a>.',

    // Feedback
    feedbackHeader: 'Something to share?',
    feedbackContent:
      'Share your thoughts on internet banking by emailing us – just remember never to send your bank details.',
    sendFeedback: 'Send feedback',

    // Your Support
    yourSupportHeader: 'Your Support',
    yourSupportContent:
      "If you're experiencing something that affects how you bank with us, we can support you, whether it be temporary or long-term health concerns, accessibility needs or money worries.",

    // Lost cards
    LostCardHeader: 'Report a card lost or stolen',
    CALostCardContent:
      'Cancel and re-order cards if they are lost, stolen or damaged.',
    AULostCardContent:
      'Get in touch with your corporate administrator to cancel and re-order cards if they are lost, stolen or damaged.',
    LostCardContent:
      'Get in touch as soon as you can on <br>0800 121 7365.</br> For more info, check out the ',
    manageDebitCardButton: 'Manage debit cards',
    LostCardContentFaq: 'FAQs',
    LostCardContentDot: '.',
    // Any Questions

    FaqDone: 'Done',
    AnyquestionTitle: 'Any questions?',
    anyQuestionsContent: 'Find the answers right here.',
    anyQuestionsHeading: 'Any questions?',
    anyQuestionsFaqLink: 'https://virginmoney.com/pca/faqs',
    anyQuestionsFaqSMELink: 'https://virginmoney.com/business/faqs',
    // AnyquestionTitle1: 'questions?',
    // Chat
    chat: 'Want to chat?',
    chatContent:
      '<p><strong>Launch live chat to talk to us now.</strong></p><p>The Virgin Money team will keep chat transcripts for training, legal and compliance reasons.</p>',

    // Call us
    callTitle: 'Talk',
    callTitleBusiness: 'Busines User',
    // callContent : 'Call the internet banking helpdesk on 0800 121 7365 for free any time, day or night. - from your landline or mobile.<p>If you’re calling from abroad, call +44 141 221 7300, though local providers may charge you for the call.</p>',
    callContent1:
      'Call 0800 121 7365 for free any time, day or night – from your landline or mobile. Calling from abroad? It’s +44 141 221 7300.',
    callContent2: 'On a call with the team right now? Securely ',
    callContent3: 'share your screen',
    callContent4: ' with them to get their help.',

    // Terms&Conditions
    TermsCondition: 'T&Cs',
    AuthorisedUserTerm: 'Authorised User Terms',
    TnCHeading: 'Terms and conditions',
    TermsConditionPageTitle: 'T&Cs',
    DownloadTermsCondition: 'Download our T&Cs',
    TCHead:
      "It's kind of boring. But here it is, if you'd like to take another look.",
    TCData: 'The terms and conditions for the Virgin Money app',
    TCData1: 'Virgin Money app background',
    TCData2:
      "The Virgin Money app is designed to be an intuitive digital banking sevice built into an app. It's available on compatible tablets and compatible mobile phones and has lots of smart tools, evolving as it learns, to help you take care of your money.",
    TCData3:
      "You will need a both a compatible tablet and a compatible mobile phone to take full advantage of all features of the app, though other mobile phones can still be used to receive text alerts. Virgin Money personal accounts can't be used for business purposes. Our app can be supported by a Virgin Money Current Account and Virgin Money Instant Savings account or any other account we agree it can be used with.",
    TCData4: 'Our accounts and services are provided by Virgin Money PLC.',
    TCData5:
      'When we refer to the "team", "we", "us" and "our"; we are referring to Virgin Money PLC.',
    TCButton: '<strong>Back to help</strong>',

    // Protected
    BankUrl:
      'https://uk.virginmoney.com/virgin/popups/FSCS-deposit-protection.jsp',
    // Protected Panel
    protectedLine:
      'Find out how eligible deposits are protected by the Financial Services Compensation Scheme.',
    ProtectedTitle: 'Protecting your money',
    // ProtectedTitle1: 'your money',

    // Demo Page
    Demo: 'Demo',
    DemoContent: '[See how key features work]',
    DemoSkipButton: 'Skip',
    BImg: 'Click on the arrows to see what we can do online',
    TimelineImg:
      "See what's happening in all your accounts in one place. And in real time too.",
    InsightsImg:
      "Look at the tiles on the screen for handy insights into how you're spending your money.",
    TaggingImg:
      'Most of your transactions are tagged automatically with handy labels. You can change tags around and create your own too.',
    SpendingImg:
      'Take control of your money by setting budgets and tracking your tagged spend.',
    SavingsPotsImg:
      'With Savings Pots you can put away a little or a lot, whatever works for you. Every penny gets you closer to achieving your goals.',
    PaymentsImg: 'Pay anyone and make transfers easily.',
    AlertsMessagesImg: "Set up text alerts so you're always one step ahead.",
    SweepsImg:
      "Set up Sweeps to automatically move money from your Virgin Money Savings account and receive texts when you're running low.",
    ProjectionsImg:
      "Look ahead and keep track of projected earnings and commitments, and receive alerts if you're going to run low.",
    HelpImg: "If you're stuck at any point just go to Help.",

    // Demo Page Ready? Go
    DemoReadyGo: 'Ready? Go',
    DemoDone: 'Done',

    // TimeLine Page
    nbaHeaderData: 'Why not add a credit card to your account?',
    nbaDisplayData:
      "if you need to buy something expensive that you can't afford to pay for all at once, a credit card is ideal. If you dont have the cash to hand - or even in your bank account - you can pay with a credit card and then spread the cost over over a number of months.",

    // feature 4
    // Financial Stories & Projection
    MicroTransaction: 'microTransactions',
    Cashpoint: 'cashpoint',
    InAndOut: 'insAndOuts',
    Projection: 'projection',
    Showing: 'Showing',
    Upto: 'up to',
    CurrencySign: '-£',
    accountDetailsInprogressHeader: 'In progress',
    accountDetailsInprogressContent: 'This is still going through',
    inAndOutFootrText: 'You had {credit} come in,\nbut {only} {debit} go out.',
    inAndOut_headerTextCurrentMonth:
      "Nothing's gone in or out\nof your account so far",
    inAndOut_headerTextOtherMonths: 'Nothing went in or out\nof your account',
    inAndOut_headerTextCurrentMonthPositiveSum: "So far you're up {sum}",
    inAndOut_headerTextCurrentMonthNegativeSum: "So far you're down {sum}",
    inAndOut_headerTextOtherMonthsPositiveSum: 'You were up {sum}',
    inAndOut_headerTextOtherMonthsNegativeSum: 'You were down {sum}',
    cashpoint_headerTextCurrentMonth: "You haven't taken out\nany cash so far",
    cashpoint_headerTextOtherMonths: "You didn't take out any cash",
    cashpoint_headerTextCurrentMonthSum:
      "You've taken out {sum} in cash so far",
    cashpoint_headerTextOtherMonthsSum: 'You took out {sum} in cash',
    cashpoint_footerText: 'You usually take out {sum} at a time.',
    noTransactionMessage:
      "Sorry but it's not possible to show payments for this account type.",
    noTransactionFound: 'No transactions found',
    takeLookAtFaq: 'Take a look at our FAQs',
    transactionReTag: '{TranNo} transaction has been retagged {TagName}',
    transactionReTags: '{TranNo} transactions have been retagged {TagName}',
    transactionUnTag: '{TranNo} transaction has been untagged',
    transactionUnTags: '{TranNo} transactions have been untagged',
    transactionGridMessage:
      "That's all we can find. Try changing your date range?",
    transactionGridMobileMessage: "That's all we can find.",
    transactionRefundDetails:
      'The merchant has confirmed that your refund is being processed. We’ll show the refund in your balance once we’ve received it. Any questions?',
    transactionRefundFaqLink:
      'https://uk.virginmoney.com/service/debit-card-refunds/',
    transactionRefundNotInBalance:
      'This won’t show in your balance yet - find out more',
    micro_headerTextCurrentMonth:
      "So far you haven't paid\nfor anything under a tenner",
    micro_headerTextOtherMonths: "You didn't pay for\nanything under a tenner",
    micro_headerTextCurrentMonthWithSum:
      "So far you've spent {sum} on things under a tenner",
    micro_headerTextOtherMonthsWithSum:
      'You spent {sum} on things under a tenner',
    micro_footerText: "That's about {sum} a pop.",
    currency: 'GBP',
    asc: 'asc',
    desc: 'desc',
    threeMonths: '3 months',
    customRange: 'Custom range',
    transactionListViewError:
      'We were unable to load your transactions at this time. Please try again later or pull down to try again now',

    //Business Promotional Tiles
    debitCardTitle: 'Debit Card',
    debitCardTileText:
      'Add up to 8 cardholders each earning cashback on all eligible spending.',
    debitCardTileBtnLabel: 'Apply now',
    mTrackTitle: 'M-Track',
    mTrackTileText:
      'Power up your business data and manage it all in one simple place.',
    marketPlaceTitle: 'Marketplace',
    marketPlaceTileText:
      'Access a world of digital tools to enhance your business.',
    closerLook: 'Take a closer look.',
    findOutMore: 'Find out more.',

    // Account Details
    availableBalance: 'Available balance',
    borrowingLimit: 'Planned borrowing limit',
    lastStatementDate: 'Last statement date',
    lastStatementBalance: 'Last statement balance',
    minPaymentDue: 'Minimum payment due',
    paymentDueDate: 'Payment due date',
    creditCardLimit: 'Credit card limit',
    AccountMoreInfoView_AvailableBalanceDisclaimer:
      "This balance may also include items that haven't gone through yet.",
    AccountMoreInfoView_AvailableBalanceDisclaimer_WithOverdraft:
      "This balance may also include items that haven't gone through yet.",
    AccountMoreInfoView_ContactMessage:
      "If you'd like to talk about this account, please call us on 0800 1217365.",
    prevSlide: '◀︎',
    nextSlide: '▶︎',
    helpButton: 'Help',
    searchKey: 'Search',
    yesText: 'Yes',
    FYI: 'FYI',
    transition: 'scale',
    current: 'current',
    creditCard: 'credit_card',
    savings: 'savings',
    loan: 'loan',
    mortgage: 'mortgage',
    moreInformation: 'More information',
    hideInformation: 'Hide information',
    dateRangeVallidationMsg:
      'Something’s not right there. Make sure the date you’ve entered is less than five years ago and before the date you want to view your transactions up to.',
    todateRangeVallidationMsg:
      'Something’s not right there. Make sure the date you’ve entered isn’t in the future or before the date you want to view your transactions from.',
    chooseDateValidationMsg:
      'Choose the date range you want show. This should be entered as DD/MM/YYYY.',
    applyFilter: 'Apply filter',

    // Account View
    accountCardBalanceText:
      'This balance may also include items that haven’t gone through yet. <br />If you’d like to talk about this account , please call us on 0800 1217365',
    availableBalanceExpalanationText:
      "Your balance shows pending transactions, including any cheques that haven't cleared yet.",
    availableBalanceWithOverdraftExpalanationText:
      "Your balance shows pending transactions, including any cheques that haven't cleared yet. Got an overdraft? You'll see it on its own.",
    HCCRavailableBalanceExpalanationText:
      "Your balance shows pending transactions, including any cheques that haven't cleared yet.",
    HCCRavailableBalanceWithOverdraftExpalanationText:
      "Your balance shows pending transactions, including any cheques that haven't cleared yet. Got an overdraft? You'll see it on its own.",
    clearedBalanceExplanationText:
      'This is your current balance excluding any cheques that haven’t cleared yet. When a cheque clears, it’ll be included here – but it may still be returned unpaid by the bank it came from.',
    accountBalanceContactUs:
      'Want to talk about this account? Get in touch with the Virgin Money team.',
    accountInterestOriginalRegularSaver:
      '10.38% Gross. Pay in up to £250 per month. Conditions apply.',
    accountInterestRegularSaver: 'Pay in up to £250 per month.',
    accountBalanceOriginalRegularSaver:
      '10.38% Gross. Pay in up to £250 per month. Conditions apply. The balance you can earn interest on increases each month by £250, any money you pay in over the cumulative monthly deposit limit each month will earn no interest – see your Summary Box. Check our website for more detail on interest rates for all our savings accounts.',
    accountBalanceRegularSaver:
      'Pay in up to £250 each calendar month and earn interest on this. Check our website for more detail on interest rates for all our savings accounts.',
    // tag
    deleteTagHeader: 'Delete this tag?',
    deleteTagContent:
      "You'll still be able to see it on your transactions, but you won't be able to use it in the future. Still happy to delete?",
    tagInfoPopupHeader: 'Tags',
    tagInfoPopupContent:
      "Now choose one of the tags from this list or tap 'My tags' to create one of your own (you can have up to 5).",
    tagSidebarHeading: 'Choose your transactions',
    tagSidebarContent:
      'Start by choosing the transaction(s) you want to tag, selecting one type only (like Groceries or Fuel).',
    rememberThisTagContent:
      "'Remember this' enables you to tag every transaction like this in the future.",
    rememberThis: 'Remember this',
    addNewTagModal: 'Add a new tag',
    menuTitle: 'Menu',
    closeButton: 'Close',
    editButton: 'Edit',
    myTagsHeader: 'My tags',
    unTagSelected: 'Untag Selected',
    tagCreateUpdatError: 'When contacting support, please quote ID: {quote-id}',
    addTag: 'Add tag',
    selected: 'Selected',
    // Digital Statements
    IEPrintIssueModalHeading: 'Your browser isn’t supported', // only for IE case
    IEPrintIssueModalBody1:
      'Sorry, due to some technical issues, you’re not able to download or print online statements using Internet Explorer. Please use another browser to download or print your statement.',
    IEPrintIssueModalBody2:
      'If you do not have access to another browser we do not recommend that you turn off paper statements. For more information, ',
    IEPrintIssueModalBody3:
      'Sorry, due to some technical issues, you’re not able to download or print online statements using Internet Explorer. Please use another browser to download or print your statement. For more information, ',
    checkoutFAQ: 'check out the FAQs.',
    digitalStatementTileContent:
      'View and download your statements whenever you need them.',
    statementSuccess: 'Great, your statement preferences have been updated',
    gotoStatements: 'Go to your statements',
    statementPreferences: 'Statement preferences',
    statementPreferencesModalHeader: 'All you need to know',
    updateStatementPreferencesModalHeader: 'All you need to know',
    digitalModalButton: 'Got it',
    digitalModalHeader: 'All you need to know',
    digitalModalHeader1: 'View your statements whenever you need them',
    digitalModalHeader2: 'Download and print your statements',
    digitalModalHeaderContent1:
      'You can now view statements for your Virgin Money accounts right here. Some types of accounts aren’t currently able to display online statements.',
    digitalModalHeaderContent2:
      'If you notice your online statement looks a little different from your regular paper statement, don’t worry. Your online statement has been stripped back a little, so it’ll only have the essential information you really need.',
    digitalModalHeaderContent3:
      'You can go ahead and download and print your statements straight from your mobile, tablet or computer.',
    digitalModalHeaderContent4:
      "Need to show your statement as proof of address? You might be able to use your online statement, but it really depends on the company you're showing it to. Some accept PDFs or printed copies of online statements – others need to see original, paper statements.",
    digitalErrorMessage1:
      'There’s been a problem loading your statement, please try again later.',
    digitalErrorMessage2: 'When contacting support,',
    digitalErrorMessage3: 'please quote ID: ',
    digitalQuoteID: 'b21ddf',
    // Statement Preferences

    statementPreferenceHeading: 'Your statements, your way',
    backToAccounts: 'Back to accounts',
    goPaperfreeLine1: 'Go paper-free to only get statements online*.',
    goPaperfreeLine2: 'Or keep paper statements to get them in',
    goPaperfreeLine3: 'the post too.',
    statementPreferenceGotAccountHeader: "Got an account that isn't here?",
    statementPreferenceGotAccountBody1:
      "Some types of accounts aren't currently able to",
    statementPreferenceGotAccountBody2: 'receive paperless statements.',
    statementPreferenceGotAccountInfo1:
      '*Device and browser restrictions may apply.',
    statementPreferenceGotAccountInfoLink1: ' Find out more in our FAQs.',
    statementPreferenceGotAccountInfo2:
      'There may be some problems downloading or printing online statements on certain combinations of devices and browsers. You can',
    statementPreferenceGotAccountInfoLink2: ' find out more in our FAQs.',
    paperfree: 'Paper-free',
    paper: 'Paper',
    statementPrefernceModalHeader1: 'Going paper-free? Great.',
    statementPrefernceModalHeader2: 'Still want paper statements? That’s fine.',
    statementPreferenceModalContent1:
      "You can access online versions of your statements whenever you need them by logging in and going to your account. They'll be updated every month and they'll be in the same format as you’re used to.",
    statementPreferenceModalContent2:
      'You’ll still get some documents, like annual summaries, in the post. And if there are any fees or charges you need to know about, you’ll still get a paper statement for the time being.',
    statementPreferenceModalContent3:
      'Got a joint account? If you go paperless, make sure the other account holder is happy not to receive paper statements.',
    statementPreferenceModalContent4:
      'Currently get your statements in Braille, large print or audio? Or have other special arrangements for your paper statements? If you go paperless, you’ll no longer get them.',
    statementPreferenceModalContent5:
      'If we have already started printing your statement, you’ll still get it in the post.',
    statementPreferenceModalContent6:
      'You can go ahead and download and print your statements straight from your mobile, tablet or computer (only if you have access to a printer, obviously).',
    statementPreferenceModalContent7:
      'If you ever need a paper statement in the future, just get in touch with us.',
    statementPreferenceModalContent8:
      'Miss all that paper? You can go back to paper statements at any time by changing your statement preferences.',
    statementPreferenceModalContent9:
      "You'll get all your statements in the post - just like you used to.",
    statementPreferenceModalContent10:
      "If you're changing from paper-free to paper statements, your preferences will be updated soon (if this month's statements have already been processed, you'll get paper statements in the post from next month).",
    statementPreferenceModalContent11:
      "By hitting 'Continue', you're confirming that you understand and agree to the above, and your preferences will be changed.",
    statementPreferenceModalContent12:
      'There may be some problems downloading or printing online statements on certain combinations of devices and browsers. You can',
    statementErrorHeader:
      "Oops, there's been a problem updating some of your statement preferences, please try again later",
    statementContinue: 'Continue',
    // sweeps
    sweepLine1: 'In my',
    sweepLine2: 'when I have <strong>less</strong> than',
    sweepLine3: '<strong>sweep</strong> money from',
    sweepLine4: 'to meet my target of',
    triggerEntryViewController_TermsOfUse_SingleAccount:
      'You can set up Sweeps to move money from your Virgin Money Instant Savings account to your Virgin Money Current Account. They can help you avoid charges but remember, they’re just automatic transfers, so will only work if there is enough money in your Virgin Money Instant Savings account - e.g. you can set up a Sweep to add £150 to your Virgin Money Current Account every time it gets below £50 but it will only sweep that if you have the £150 in your Virgin Money Instant Savings account. Make sense? They can take a teeny bit of time to show on your account but you’ll get a text each time a Sweep happens, even if it’s at the weekend. And you can change your Sweep settings at any time.',
    infoPopupContentForJointAccountHolder:
      'Low balance sweeps are automatic transfers from our chosen Virgin Money Instant Savings account to our joint Virgin Money Current account. One of you can set up Sweeps to avoid charges and make payments when your current account runs low (drops below the lower balance trigger). However, Sweeps can only work if there is enough money in your chosen savings account. If there isn’t, the Sweep may not be able to reach the joint account’s lower target balance and the account will be charged. Sweeps can happen several times a day (including weekends).\n\nEvery time there’s a sweep both joint account holders will get a text to let them know what’s happening. Likewise when one of you edits sweep settings, both joint account holders will be made aware of the change.',
    infoPopupContent:
      'Low balance sweeps are simply automatic transfers from your Virgin Money Instant Savings account to your Virgin Money Current account. You can set up Sweeps to avoid charges and make payments when your current account runs low (drops below your lower balance trigger). However, Sweeps can only work if there is enough money in your savings account. If there isn’t, the Sweep may not be able to reach your lower target balance and you may have to pay charges. Sweeps can happen several times a day (including weekends). Each time there’s a Sweep you’ll get a text to let you know what’s happening. You can change the settings any time you like within internet banking or the app.',
    infoPopupHeader: 'User agreements',

    infoPopupButton: 'OK, I understand',
    deletePopupHeader: 'Delete',
    deletePopupContent: 'Are you sure you want to delete this sweep?',
    okButton: 'OK',
    deleteSweep: 'Delete Sweep',
    sweepCreationPopup: 'Your Sweep has been created',
    sweepUpdatePopup: 'Your Sweep has been updated',
    sweepDeletePopup: 'Your Sweep has been deleted',
    sweepNotDeletePopup: 'Sweep not found',
    doneButton: 'Done',
    editMySweep: 'Edit my Sweep',
    createMySweep: 'Create my Sweep',
    createMySweepNewUser: 'Create a Sweep',

    // Alerts&Sweeps page
    alertSweepTitle: 'Alerts and Sweeps',
    alertsSweepsHead: 'Alerts and Sweeps',
    wbaMessage:
      "Keep track of your money with weekly text updates that tell you how much you've got left in your account.",
    alertMessage:
      'Set up alerts to receive text messages when you reach a certain amount on your chosen account.',
    sweepMessage:
      'Set up Sweeps to be notified when your threshold is reached and select the account you want your money to be swept from to meet your target balance.',
    alerts: 'Alerts',
    errorMessage: 'Something techie has gone wrong. Please try again.',
    cancelButton: 'Cancel',
    confirmButton: 'Confirm',
    confirmButtonSweep: 'Create Sweep',
    wba: 'Balance updates',
    confirmButtonUpdate: 'Create alert',
    confirmButtonAlert: 'Create alert',

    continueButton: 'Continue',
    infoButton: 'Info',
    deleteButton: 'Delete',
    createSweep: 'Create Sweep',
    createUpdate: 'Create a weekly balance update',
    editMyUpdate: 'Edit my weekly balance update',
    editSweep: 'Edit Sweep',
    createAlert: 'Create alert',
    AlertSweep: 'Alert and Sweep.',
    footerLabelSweep:
      'Just so you know, you might still get one more balance sweep from us.',
    footerLabelAlert:
      'Just so you know, you might still get one more balance alert from us.',
    footerLableWBA:
      'Just so you know, you might still get one more alert from us.',
    footerLabelJointAccountHolder:
      'This Sweep was set up by your joint account holder. You can’t edit it, but you can give them a nudge to do it',
    maxSweepPopupHeader: 'An alert about your Sweeps',
    maxWBAPopupHeader: 'Your balance updates',
    maxSweepPopupData:
      'You can only have one low balance Sweep per account. But you can edit your existing Sweeps.',
    appErrorForAlerts:
      'We were unable to load your alerts or Sweeps at this time.',
    alertSweepValidationMsg:
      'Oops. You’ll have to enter an amount here to continue.',
    //	triggerDashboardViewController_Failure_Details_Text: 'We were unable to load your alerts at this time. Please try again later',
    //	failedToLoadSweeps: 'We were unable to load your Sweeps at this time. Please try again later',
    //	failedTpLoadAlertsNSweeps: 'We were unable to load your alerts or Sweeps at this time. Please try again later',
    triggerDashboardViewController_NoEligibleAccounts_Title:
      'No available accounts', // not used
    triggerDashboardViewController_NoEligibleAccounts_Alerts:
      'To use alerts, you need to open an account which supports them.', // not used
    triggerDashboardViewController_NoEligibleAccounts_Sweeps:
      'To use Sweeps, you need to open an account which supports them.', // not used
    triggerDashboardViewController_NoEligibleAccounts_AlertsSweeps:
      'To use alerts or Sweeps, you need to open an account which supports them.', // not used
    triggerDashboardViewController_NoEligibleAccounts_ButtonTitle: 'Retry', // not used
    triggerDashboardViewController_CantCreateTrigger_Title:
      'Server unavailable', // to ask
    triggerDashboardViewController_CantCreateTriggerAlert_Message:
      'Can’t create any alerts', // to ask
    triggerDashboardViewController_CantCreateTriggerSweep_Message:
      'Can’t create any Sweeps', // to ask
    triggerEntryViewController_ThresholdAmount_Minimum_Error_Message:
      'Threshold amount has to be at least 0 pounds.', // to ask
    triggerEntryViewController_TargetAmount_Minimum_Error_Message:
      'Target amount has to be at least 100 pounds.', // to ask
    triggerEntryViewController_TargetAmount_Error_Message:
      'Target amount has to be at least 100 pounds larger than the threshold amount.',
    triggerListCell_lowerThresholdAlert_Title_Prefix: 'Low balance alert',
    triggerListCell_projectionThresholdAlert_Title_Prefix:
      'Projection low balance alert', // differ
    triggerListCell_upperThresholdAlert_Title_Prefix: 'High balance alert',
    triggerEntryViewController_ending: 'ending',
    projectionLowBalanceAlert: 'Projection balance alert', // removed low word
    sweepAlert: 'Sweep alert',
    jointAccountHolders: 'Joint account holders',
    confirmChanges: 'Confirm changes',

    projection404Title:
      'See in advance how the rest of your month is panning out.',
    projection404Subtitle: 'Set up Projections',

    projection409_0Title:
      "You're all set up, now we're just crunching the numbers.",
    projection409_0Subtitle: 'Calculating...',

    projection409_1Title:
      "We don't have enough to go on at the moment - please try again soon.",
    projection409_1Subtitle: 'Try again soon',
    projection409_1NotEnoughData: '##days## days left...',
    projection409_1NotEnoughDays: '##days##',

    projection409_2Title:
      "Your preferences have been updated, We're just crunching the numbers.",
    projection409_2Subtitle: 'Calculating...',

    projection500Title: 'There was an error retrieving your Projection',
    projection500Subtitle: 'Please try again later',

    projection200GoodTitle:
      "Great news, looks like you'll be in the green 'til payday.",
    projection200GoodSubTitle: 'Go to Projections',

    projection200BadTitle:
      "You're running low - top up to ensure your bills get paid.",
    projection200BadSubtitle: 'Review Projections',
    // projectionInformation :'When I am projected to have <strong>{lessMore}</strong> than <strong>£{thresholdAmount}</strong> in my <strong>{accountName}</strong> please send me a text.',

    // Alerts
    // WBA
    createAnUpdate: 'Create a balance update',
    wbaTitle: 'Weekly balance update',
    alertCreationPopup: 'Your alert has been created',
    alertUpdatePopup: 'Your alert has been updated',
    createMyAlertNewUser: 'Create an alert',

    createMyAlert: 'Create my alert',
    editMyAlert: 'Edit my alert',
    inMy: 'In my',
    whenIHave: 'when I have',
    than: 'than',
    send: '<strong>send</strong> me an alert via',
    sms: 'text',
    maxAlertPopupHeader: 'An alert about your alerts',
    maxAlertPopupData:
      'You can only have one high and one low balance alert per account. But you can edit your existing alerts.',
    maxWBAPopupData:
      'You can only set up one weekly balance update per account. But you can go ahead and edit your existing balance updates if you need to.',
    // Projection
    projectionLine2: 'when my projected balance is <strong>below</strong>',
    projectionLine3: '<strong>send</strong> me an alert via',
    projectionLine4: '<strong>text</strong>',
    projectionUpdationPopup: 'Your alert has been updated',
    // ProjectionFinancialStoryPreviewCell
    projectionFinancialStoryPreviewCellTitleNotEnabled:
      'See in advance how the rest of your month is panning out.',
    projectionFinancialStoryPreviewCell_SubTitle_NotEnabled:
      'Set up Projections',
    projectionFinancialStoryPreviewCellTitleNotEnoughData:
      "We don't have enough to go on at the moment - please try again soon",
    projectionFinancialStoryPreviewCell_SubTitle_NotEnoughData:
      '##days## days left...',
    projectionFinancialStoryPreviewCellSubTitleNotEnoughDataDays: '##days##',
    projectionFinancialStoryPreviewCellSubTitleNotEnoughDataBackupTitle:
      'Try again soon',
    projectionFinancialStoryPreviewCellTitleProjectionInProgress:
      "You're all set up, now we're just crunching the numbers",
    projectionFinancialStoryPreviewCellSubTitleProjectionInProgress:
      'Calculating...',
    projectionFinancialStoryPreviewCellTitleProjectionUpdatingPreferences:
      "Your preferences have been updated, we're just crunching the numbers.",
    projectionFinancialStoryPreviewCellSubTitleProjectionUpdatingPreferences:
      'Calculating...',
    projectionFinancialStoryPreviewCellTitleGoodProjectionResult:
      "Great news, looks like you'll be in the green 'til payday.",
    projectionFinancialStoryPreviewCellSubTitleGoodProjectionResult:
      'Go to Projections',
    projectionFinancialStoryPreviewCellTitleBadProjectionResult:
      "You're running low - top up to ensure your bills get paid.",
    projectionFinancialStoryPreviewCellSubTitleBadProjectionResult:
      'Review Projections',
    projectionFinancialStoryPreviewCellTitleProjectionError:
      'There was an error retrieving your Projection',
    projectionFinancialStoryPreviewCellSubTitleProjectionError:
      'Please try again later',

    // ProjectionsExpandedView (View which gets updated when wheel spin)
    projectionsExpandedViewControllerProjectionsSettings: 'Projection settings',
    projectionsExpandedItemViewYoureGoodToGoBalanceHeading:
      "We predict you're good to go. You should have",
    projectionsExpandedItemViewThisIsMadeUpOfSubHeading:
      'before your next earning. This is made up of',
    projectionsExpandedItemViewThisIsMadeUpOfWthin31DaysSubHeading:
      'over the next 31 days. This is made up of',
    projectionsExpandedItemViewCurrentBalance: 'Current balance',
    projectionsExpandedItemViewCommitments: 'Commitments',
    projectionsExpandedItemViewTomorrowsEarnings: "Tomorrow's earnings",
    projectionsExpandedItemViewEssentialSpend: 'Essential spend',
    projectionsExpandedItemViewLowBalanceLimit: 'Low balance limit',
    projectionsExpandedItemViewSpinTheWheelFootNote:
      'Spin the wheel to find out more',
    projectionsExpandedItemViewSpinTheWheelToSeeTheFutureFootNote:
      'Spin the wheel to see what the future may look like',
    projectionsExpandedItemViewYourCurrentBalanceHeading:
      'Your current balance is',
    projectionsExpandedItemViewThisMayDifferFootNote:
      'This might be different to your available balance\n(you can check this in your account screen)',
    projectionsExpandedItemViewYouHaveXCommitmentsPart1Heading: 'You have',
    projectionsExpandedItemViewYouHaveXCommitmentsPart2Heading:
      'commitments. These come to',
    projectionsExpandedItemViewYouHaveOneCommitmentHeading:
      'You have 1 commitment. This comes to',
    projectionsExpandedItemViewYouHaveNoCommitmentsHeading:
      'You have no commitments',
    projectionsExpandedItemViewYouHaveXCommitmentsWithin31DaysPart2Heading:
      'commitments. These come to',
    projectionsExpandedItemViewYouHaveOneCommitmentWithin31DaysHeading:
      'You have 1 commitment. This comes to',
    projectionsExpandedItemViewYouHaveNoCommitmentsWithin31DaysHeading:
      'You have no commitments',
    projectionsExpandedItemViewYouveTaggedHeading: "You've tagged",
    projectionsExpandedItemViewAsEssentialSpendSubHeading:
      'as essential spend. Your top tags are',
    projectionsExpandedItemViewSingagEssentialSpendSubHeading:
      'as essential spend. Your tag is',
    projectionsExpandedItemViewNoTagsAsEssentialSpendSubHeading:
      'You have no essential spend',
    projectionsExpandedItemViewAsEssentialSpendWithin31DaysSubHeading:
      'as essential spend. Your top tags are',
    projectionsExpandedItemViewSingagEssentialSpendWithin31DaysSubHeading:
      'as essential spend. Your tag is',
    projectionsExpandedItemViewNoTagsAsEssentialSpendWithin31DaysSubHeading:
      'You have no essential spend',
    projectionsExpandedItemViewYourNextEarningHeading:
      'The next cash coming into your account should be',
    projectionsExpandedItemViewNoNextEarningHeading:
      'There is no cash coming into your account in the next 31 days',
    projectionsExpandedItemViewTomorrowsEarningHeading:
      'You have cash coming in tomorrow',
    projectionsExpandedItemViewTomorrowsEarningRunningLowSubHeading:
      'but it looks like you may still run low',
    projectionsExpandedItemViewYouCanChangeThisFootNote:
      'You can change this in Projection settings',
    projectionsExpandedItemViewYouCanChangeTheseFootNote:
      'You can change these in Projection settings',
    projectionsExpandedItemViewYouCanManageThisFootNote:
      'You can manage this in Projection settings',
    projectionsExpandedItemViewYouCanManageTheseFootNote:
      'You can manage these in Projection settings',
    projectionsExpandedItemViewYouCanReviewThisFootNote:
      'See this in Projection settings',
    projectionsExpandedItemViewYouCanViewThisFootNote: 'See this below',
    projectionsExpandedItemViewYouCanViewTheseFootNote:
      'See what these are below',
    projectionsExpandedItemViewWarningPart1Heading:
      "Looks like you'll go below your\nlow balance limit of",
    projectionsExpandedItemViewWarningPart2Heading: 'on',
    projectionsExpandedItemViewProjectedIn: 'This is projected in ',

    // Projection Screen
    projectionSummaryHeaderNoWarningDays:
      "We predict you're good to go. You should have",
    projectionSummaryHeaderWarningDays:
      "Looks like you'll go below your low balance limit of {amount} on",
    projectionSummaryFooter: 'Spin the wheel to find out more',
    projectionTagsHeader: "You've tagged",
    projectionTagsContent: 'as essential spend. Your top tags are',
    projectionTagsContent1: 'as essential spend. Your tag is',
    projectionTagsFooter: 'You can change these in Projections settings',
    projectionCommitmentsHeader: 'You have no commitments',
    projectionCurrentBalanceHeader: 'Your current balance is',
    projectionCurrentBalanceFooter:
      'This might be different to your available balance (you can check this in your account screen)',
    projectionBalanceHeader: 'The next coming into your account should be',
    projectionBalanceFooter:
      'This is projected in # days on the # of July. See this in Projection settings',
    projectionSettingsCancel: 'Cancel',
    projectionSettingsOptOutOfProjections: 'Opt out of Projections',
    projectionSettingsEarningsAndCommitments: 'Earnings and commitments',
    projectionSettingsEssentialSpending: 'Essential spending',
    projectionSettingsAlertsAndNotifications: 'Alerts and notifications',
    projectionSettingsEarningsAndCommitmentsHeader:
      'Check your earnings and commitments',
    projectionSettingsEarningsAndCommitmentsEarnings: 'Earnings',
    projectionSettingsEarningsAndCommitmentsStandingOrders: 'Standing orders',
    projectionSettingsEarningsAndCommitmentsDirectDebits: 'Direct Debits',
    projectionSettingsEarningsAndCommitmentsLastKnown: 'Last known',
    projectionSettingsEarningsAndCommitmentsFrequency: 'Frequency',
    projectionSettingsEarningsAndCommitmentsLastKnownAmount:
      'Last known amount',
    projectionSettingsDone: 'Done',
    projectionSettingsEssentialSpendingHeader:
      "Select the tags you regularly spend money on and they'll be included in your Projections",
    projectionSettingsEssentialSpendingOurTags: 'Our tags',
    projectionSettingsEssentialSpendingYourTags: 'Your tags',
    projectionSettingsAlertsAndNotificationsHeader:
      "Tell us how much you need left in your account. We'll alert you when you fall below that limit",
    projectionSettingsAlertsAndNotificationsContent: 'When I have a balance of',
    projectionSettingsAlertsAndNotificationsFooter:
      'Show me an on screen notification',
    projectionAlertAndNotificationsToggleText:
      'Send me a text when my balance is projected to be less than this',
    projectionLeaveProjectionsSetupPopupHeader: 'Leave Projections setup',
    projectionLeaveProjectionsSetupPopupContent:
      'Are you sure you want to leave Projections setup? Your changes will not be saved.',
    projectionLeaveProjectionsSetupPopupCancelButton: 'Cancel',
    projectionLeaveProjectionsSetupPopupLeaveSetupButton: 'Leave setup',
    projectionOptOutOfProjectionsPopupHeader: 'Opt out of Projections?',
    projectionOptOutOfProjectionsPopupContent:
      'Are you sure you want to opt out of Projections?',
    projectionOptOutOfProjectionsPopupCancelButton: 'Cancel',
    projectionOptOutOfProjectionsPopupOptOutButton: 'Opt out',
    projectedCrunchingHeader1: "We're just crunching the numbers for you now.",
    projectedCrunchingHeader2:
      "It'll take a little time to calculate everything, so check back later.",
    projectionDoneButtonText: 'Done',
    projectionSpinWheelText: 'Spin the wheel to find out more',
    projectionSettingsCancelButton: 'Cancel',

    projectionSettingsOptOutOfProjection: 'Opt out of Projections',
    projectionSettingsDoneButton: 'Done',
    projectionAlertsDropdownOption1: 'in my account',
    projectionAlertsDropdownOption2: 'in my overdraft',
    projectionPredictionTotalString: 'Total',
    projectionYouHaveString: 'You have ',
    projectedCommitmentBeforeYourNextEarnings:
      ' projected commitments before your next earnings',
    projectedCommitments: ' projected commitments',
    projectionPredictionEarningString: 'Earning',
    projectedPredictionEssentialSpendPreviosString:
      'Essential spend based on previous spending patterns',
    projectedBalanceInNext31Days: 'Your projected balance in the next 31 days',
    projectionPredictionYourProjectedBalanceBeforeNextEarning:
      'Your projected balance just before your next earning',
    projectedPredictionCurrentBalance: 'Current balance',
    projectedPredictionYourThreshold: 'Your threshold',
    TutorialProjectionsslide1Text:
      "To start, we will take into account what you've tagged as earnings",
    TutorialProjectionsslide2Text:
      'Review your commitments - these are standing orders and Direct Debits on your account',
    TutorialProjectionsslide3Text:
      'Select the tags which are essential to you, and we will incorporate the spending on these tags to make your projection more relevant',
    TutorialProjectionsslide4Text:
      'Look ahead and keep track of projected earnings and commitments, and receive alerts if you’re going to run low',
    TutorialProjectionsslide5Text:
      'We will give you a projected discretionary balance (good to go) or give you a heads up on when you may be running low',
    TutorialProjectionsslide6Text: 'Ready? Go',

    // Payment Thank you page
    trnasferOneOff: "Your money's on its way",
    paymentSuccesHeadingSO: "Your payment's been set up",
    paymentSuccesHeadingOneOff: "Your money's on its way",
    paymentSuccesSOFooterTomorrow: 'Your first payment will be made ',
    paymentSuccesSOFooterDate: 'Your first payment will be made on',
    paymentSuccesFDPFooterTomorrow: 'Your payment will be made ',
    paymentSuccesFDPFooterDate: 'Your payment will be made on ',
    scheduledFooter:
      'Please allow until tomorrow or the next working day for it to appear.',
    paymentSuccessSubHeaderFDP:
      'Your payment to <strong>{payeename}</strong> for <strong>{amount}</strong> has been scheduled.',
    paymentSuccessSubHeaderSO:
      'Your repeating payment to <strong>{payeename}</strong> for <strong>{amount}</strong> has been scheduled.',

    paymentSuccessSubHeaderOneOff:
      'Your payment for <strong>{amount}</strong> has been sent to <strong>{payeename}</strong>.',
    transferSuccessSubHeaderOneOff:
      'Your transfer to <strong>{payeename}</strong> has gone through for <strong>{amount}</strong>.',

    // Payment page
    nicknameHintText: 'Only you’ll see this.',
    nicknameHintTextSRD:
      "Give this person or company a nickname (like ‘Mum’ or ‘Gas bill’). This is what they'll be called on internet banking or the app – and it’s only you that’ll see it. Not got a nickname for them? Just pop their name in again.",
    accountNameHintText:
      'This is the name of the person who holds the account with this business',

    fraudTitle: 'Protect yourself from fraud and scams',
    fraudIntro1:
      'Your bank and other trusted organisations will never ask you to move your money - but scammers will.',
    fraudIntro2:
      'So before you add this payee and send your money, take some time to stop and think:',

    fraudQuestions: [
      "Is someone you don't know pressurising you to make this payment?",
      'Have you been contacted by someone requesting you to move or transfer money to another account?',
    ],
    fraudRecovery:
      "If you make a payment to this payee and it turns out to be a scam, it's unlikely your money will be recovered. So if you're not sure, don't risk it.",
    fraudMoreInformation1: 'For more information, visit the',
    fraudMoreInformation2: 'on our website',
    fraudMoreInformationLinkUrl: '/virgin/service/staying-safe-online/',
    fraudMoreInformationLinkName: 'security section',
    fraudConfirm:
      "By ticking this box you confirm you're happy to add this payee and proceed with payments to them.",
    editpayeeHeader: 'Edit payment contact',
    managePaymentLink: 'Manage your payments',
    paymentLink: 'Payment',
    crossIcon: 'cross',
    transferLink: 'Transfer',
    managePayeeLink: 'Manage who you pay',
    fromTitle: 'From',
    toTitle: 'To',
    payFrom: 'Paying from?',
    transFrom: 'Transfer from?',
    transTo: 'Transfer to?',
    howMuchTitle: 'How much?',
    currentTitle: 'current',
    available: 'available',
    newPayeeLink: 'Pay someone new',
    reference: 'Reference',
    accountHolderName: 'Account holder name',
    when: 'Date',
    repeatPayment: 'Repeat this payment',
    repeatPaymentText: 'Repeat this payment?',
    howOften: 'Repeat this payment',
    startDate: 'Start payment',
    stopitWhen: 'Stop payment',
    pickdate: 'On a set date',
    noOfTimes: 'After a set number of payments',
    ending: 'Ending',
    Weekly: 'Every week',
    twoWeekly: 'Every 2 weeks',
    threeWeekly: 'Every 3 weeks',
    fourWeekly: 'Every 4 weeks',
    monthly: 'Every month',
    twoMonthly: 'Every 2 months',
    threeMonthly: 'Every 3 months',
    sixMonthly: 'Every 6 months',
    anually: 'Every year',
    archivedPaymentsHead: 'Archived payments',
    archivedPaymentAll: 'All',
    payments: 'Payments',
    transfers: 'Transfers',
    directDebits: 'Direct Debits',
    back: 'Back',
    archived: 'Archived',
    managePaymentTitle: 'Manage your payments',
    managePayee: 'Manage your payee',
    cancel: 'Cancel',
    accountLabel: 'Account',
    lastAmount: 'Last amount',
    lastPayment: 'Last payment',
    type: 'Type',
    status: 'Status',
    accountNumber: 'Account number',
    sortCode: 'Sort code',
    editSortCode: 'Sort code',
    amount: 'Amount',
    nextDue: 'Due',
    paid: 'Paid',
    done: 'Done',
    delete: 'Delete',
    managePayments: 'Manage your payments',
    addPayeeContent: 'Pay someone new',
    editPayeeContent: 'Edit payee',
    editPayeeAccountType: 'Edit payee - Account Type',
    payeeName: 'Payee name',
    payeeSortCode: 'Sort code',
    payeeOrbill: 'Is it a bill or person',
    payeeAccountNumber: 'Account number',
    payeeReference: 'Reference',
    payeeNickName: 'Nickname',
    NAME: 'name',
    DELETE_PAYMENT_TYPE: 'DELETE_PAYMENT',
    chooseDate: 'Choose a date',
    schedule: 'schedule',
    end_condition: 'end_condition',
    nameOfThePerson: 'Name on account',
    nameOfThePersonHelpText:
      'We’ll ask their bank if the name matches what you’ve entered. You only need one name for a joint account.',
    nameOfTheCompany: 'Business name',
    nameOfTheCompanyHelpText:
      'We’ll ask their bank if the name matches what you’ve entered. Trading names might not match - an invoice should show the account name.',
    referenceHintText:
      'Please enter the 16 numeric card reference number starting with 47759 from your bill',
    theirSortCode: 'Sort code',
    theirAccountNo: 'Account number',
    ReferencePayeeText: 'Helps you and the payee recognise the payment.',
    referenceErrorMsgMoveMoney: 'Please enter a reference for this payment.',
    referenceErrorMsgMoveMoneyTransfer:
      'Please enter a reference for this payment.',
    addPayeeCheckboxText1: 'Save in payee list',
    addPayeeCheckboxText2:
      'Save time and hassle when making and authorising payments to this payee.',
    addPayeeMoreInfoText:
      'Keep these details so you don’t have to enter them again and again. Saving this payee in your secure payee list could also help reduce the steps required to authorise future payments to them (payment approval limits will still apply).',
    addPayeeNickName: 'Nickname',
    addPayeeNickNameText1:
      'Allows you to use an alternative name for the payee. This will appear within online banking but',
    addPayeeNickNameText2: ' not on your statements.',
    bill: 'Bill',
    noOfTime: 'noOfTime',
    noOfTimeValidationMessage: 'Number of time should be of 2 digits or less',
    addPayee: 'Continue',
    addNewPayeeBack: 'Your payment contacts',
    addNewPayeeHeader: 'New payment contact',
    saveDetails: 'Save in payee list',
    payeeRequestPacket_Name: 'name',
    nameValidationMessage: 'Please use letters and spaces only.',
    payeeRequestPacket_account_id: 'account_id',
    payeeRequestPacket_sort_code: 'sort_code',
    sort_codeValidationMessage: 'Sort Code should be a 6-digit number',
    payeeRequestPacket_account_number: 'account_number',
    account_numberValidationMessage:
      'Account number should be a 12-digit number',
    payeeRequestPacket_reference: 'reference',
    referenceValidationMessage: 'Invalid reference',
    payeeRequestPacket_account_name: 'account_name',
    payeeRequestPacket_single_use: 'single_use',
    payeeRequestPacket_nick_name: 'display_name',
    display_name: 'display_name',
    nick_nameValidationMessage:
      'Nickname should not have any special characters',
    deletePayment: 'Delete payment contact',
    deleteBeneficiary: 'Delete beneficiary',
    editPaymentText:
      'Your payment has been edited, but the changes could take until tomorrow (or the next working day) to appear.',
    deletePaymentText:
      'Your payment has been cancelled, but might still appear until tomorrow (or the next working day).',
    ok: 'OK',
    okButtonText: 'OK',
    beneficiary_id: 'beneficiary_id',
    DELETE_PAYEE_TYPE: 'DELETE_PAYEE',
    placeHolderContent: "Don't forget",
    creditPopUpHeader: 'Please be aware...',
    creditPopUpBody:
      "If you use your credit card, there will be a cash advance fee to pay of 3% (min £3). The cash advance interest rate will also apply as per your credit card agreement. Are you sure that's OK? For further information please call the team on 0800 121 7365.",
    deletePayeePopUp: 'Are you sure you want to delete <br/> this beneficiary?',
    deletePayeePopUpmobile: 'Are you sure you want to delete this beneficiary?',
    AmountValidationMessage: 'Invalid amount',
    mandateTypeDD: 'dd',
    mandateTypeSO: 'so',
    paymentContactTitle: 'Your payment contacts',
    nickName: 'Nickname',
    viewDetails: 'View details',
    thankYouText: 'Thank you',
    regularPayment: 'Your payment for ',
    regularTransfer: 'Your transfer to ',
    paymentThroughText: 'has gone through for',
    thankYouFooterText:
      'Please allow until tomorrow or the next working day for it to appear.',
    cancelTitle: 'Cancel',
    sureTitle: 'Are you sure?',
    active: 'Active',
    inactive: 'Inactive',
    single_use: 'single_use',
    account_Id: 'account_Id',
    edit: 'Edit',
    errorHeader: 'Error',
    eligibleErrMsg:
      'you cannot make an internal transfer because you have less than two eligible accounts',
    errorButton: 'OK',
    whenIcancel: 'When I cancel it',
    endDate: 'Stop payment',
    howManyTimes: 'Number of payments',
    makePayment: 'Make payment',
    paymentBtn: 'Make payment',
    transferBtn: 'Make transfer',
    btnTextPaymentPopup: 'payment',
    btnTextTansferPopup: 'transfer',
    leaveMoveMoneyBodyText:
      "If you leave this page now, your transaction won't be completed.",
    leaveModalSecondaryButtonText: 'Leave page',
    leaveMoveMoneyPrimaryButtonText: 'Continue with {paymentType}',
    duplicatePayeeErrrmsg:
      'It looks like you’ve added these payment details before. Check the details you’ve entered and try again or choose this person or company from the list of who you pay.',
    makeTransfer: 'Make transfer',
    loadingPaymentText: 'Loading payments data.....',
    isRepeat: 'Yes',
    confirmCancel: 'Confirm cancel?',
    confirmCancelWeb: 'Confirm cancellation',
    accountName: 'Name',
    managePaymentFooter:
      "That's all of them. Any new payments you make will appear here.",
    archivedPaymentFooter:
      "That's all of them. Any archived payments will appear here.",
    editpopupStartText:
      "These changes only apply to this person or company for future payments.  If you are already paying them with a Direct Debit or standing order, you need to update that to the new details you've just saved.",
    editpopupEndText:
      "If you've got this person saved as a payee somewhere else, for example in Clydesdale or Yorkshire Bank internet banking, you'll need to update that separately too.",
    cancelThisTransfer: 'Cancel this transfer',
    cancelThisTransferweb: 'Cancel this transfer',
    cancelThisPayment: 'Cancel this payment',
    NextButton: 'Next',
    Yes: 'Yes',
    No: 'No',
    editManagePayment: 'Edit payment',
    managePayment: 'Manage payment',
    managePaymentHeader: 'Manage payment',
    allDoneMessage: "All done. You're good to go.",
    toolTipMessageComplexSO:
      'This payment can’t be edited online. Need to make changes to it? Give us a call or pop into your local branch.',
    unAllocatedHeader: 'Your Savings Pots are currently overallocated.',
    unAllocatedContent: 'Please take action to correct this immediately',
    availBalance: 'Available balance',
    amountValidationError:
      "You can't transfer more money out of a pot than is actually in it.",
    loadingPayeeText: 'Payee list loading...',
    someoneNewText: 'Someone new?',
    amountError: 'Cannot enter amount greater than available amount',
    oneOffPaymentText: 'Make a one-off transfer between your accounts',
    oneOffReapetPaymentText: 'Set up a regular transfer',
    thankOneOffRepeatText:
      'Please allow until tomorrow or the next working day for it to appear',
    setUpRegularTransfer: 'Set up a regular transfer',
    potMessage:
      "This payee can't set up standing orders or future-dated payments. If you choose it, you will only be able to make an single payment. Is this OK?",
    payingTo: 'Paying to?',
    whenHappen: 'When would you like this to happen?',
    whenGo: 'When do you want it to go through?',
    loadingAccounts: 'Loading accounts...',
    referenceText: 'Enter reference',
    potsLoading: 'Saving Pot loading....',
    payeeRef: 'Ref',
    noPayeeMsgFirstLine: "Oops! You don't have anyone set up yet.",
    noPayeeMsgSecondLine:
      "Go back to the Payment screen and hit 'Someone new?'",
    chooseValue: 'Choose a value',
    paymentText: 'Your payment for ',
    lastPaymentReference: 'Last payment reference',
    transferText: 'Your transfer to ',
    validationHead: 'By the way',
    validationMsg:
      "It's not possible to process a payment after 4pm on the previous working day.",
    PayeeAccountNumber: 'Number',
    newPayee: 'Who you pay',
    subHeaderContent:
      "Choose <strong>'Person'</strong> to enter the details of the person or business you want to pay or <strong>'Company'</strong> to search for big organisations like credit card companies and local authorities - this can come in handy when you need to pay a bill or invoice.",
    addCompany:
      'If the company you want to pay is on our database, their payment details will be filled in for you. And if their details ever change in the future, they’ll be updated automatically.',
    payNew: 'Pay someone new',
    sweepTargetValidationMsg:
      'Oops. There has to be at least £100 between each amount.',
    referenceNumberText:
      'A note to help you remember why you moved this money. This will appear in your transactions list and statement.',
    repeatingPaymentText:
      "Choose <strong>'One-off'</strong> to move this money just once or <strong>'Repeating'</strong> if you want to set up a standing order.",
    paymentFrequencyText: 'Payment type',
    oneOffPayment: 'One-off payment',
    repeatingPayment: 'Repeating payment',
    datePickerText:
      'Use the date picker to select when you want this to happen. Alternatively, enter it in the format DD/MM/YYYY.',
    madePaymentText: 'has been made.',
    for: 'for',
    paymentSuccess: 'Success. Your payment will clear within 2 hours.',
    goToAccountsText: 'Go to your accounts',
    makeAnotherPaymentText: 'Make another payment or transfer',
    endDatePickerText:
      'Use the date picker to select when you want the repeating payment to stop. Alternatively, enter it in the format DD/MM/YYYY.',
    IncorrectFormatPayeeErrorMsg:
      'Something is wrong with the format of the information in your entry. Please check your use of special characters in the Beneficiary Name, Address or Reference Fields.',

    display_nameErrorMessage:
      'Enter a nickname for the person or company you want to pay then try again.',

    // Dispute payments
    DISPUTE: {
      THRESHOLD_MESSAGE: {
        MINIMUM: {
          title: 'You can’t dispute this payment yet',
          details:
            'It needs to be at least 30 days since the payment was made.',
        },
        MAXIMUM: {
          title: 'You can’t dispute this payment',
          TRAVEL: {
            details:
              'It’s been more than 120 days since your expected departure date.',
          },
          SERVICES: {
            details:
              'It’s been more than 120 days since the date you expected the service to start.',
          },
          GOODS: {
            details:
              'It’s been more than 120 days since the expected delivery date.',
          },
        },
      },
    },

    pendingPaymentTitle: 'The payment is pending',
    pendingPaymentText1:
      "If it's been pending for more than 5 days, contact the seller to see what's going on.",
    helpWithPaymentTitle: 'Help with this payment',
    reportSuspectedFraudSubTitle: 'Report suspected fraud',
    reportSuspectedFraudDescriptionText:
      'If you don’t recognise this payment, chat to us and we’ll secure your account.',
    helpWithPaymentSomethingElseTitle: 'Something else?',
    helpWithPaymentSomethingElseText: 'Chat to Redi, our digital host.',
    helpWithPaymentDisputeTitle: 'Dispute this payment',
    helpWithPaymentDisputeText:
      'If there’s a problem with your purchase, we’ll investigate and try to get your money back.',
    helpWithPaymentDisputeModalTitle: 'Disputing a payment',
    weWillInvestigateText: 'We’ll investigate if you’ve:',
    beforeYouStart: 'Before you start, check that:',
    weWillInvestigateBulletlist: [
      'not received goods, travel or services',
      'been charged the wrong amount',
      'received items that are damaged or wrong',
    ],
    beforeYouStartBulletlist: [
      'the payment isn’t pending',
      'it’s been more than 30 days since the payment was made',
      'it’s been less than 120 days since you received, or were due to receive, goods, services, or travel',
      'you’ve already contacted the seller',
    ],
    jointAccountsSubHeader: 'Joint accounts',
    jointAccountSubText:
      'Any account holder can dispute a payment, but we can only send updates to the person who made the purchase.',
    youCanDisputeMultiplePaymentText:
      'If you want to dispute multiple payments, you’ll need to give us a call.',
    disputingMultiplePayments: 'Disputing multiple payments',
    disputeThisPayment: 'Dispute this payment',
    disputeMultiplePayments: 'Dispute multiple payments',
    callPaymentTitle: 'Call us',
    callUsNumber: '0800 121 4254',
    callPaymentText:
      'We’re here Monday to Friday, 8am to 7pm, Saturday 9am to 5pm. Calls are free from UK landlines and personal mobile phones.',
    disputePaymentTitle: 'Getting started',
    disputePaymentText1:
      'To help you try to get your money back, we need to ask you some questions about your dispute. It should only take a few minutes.',
    disputePaymentSubTitle: "What's gone wrong?",
    disputePaymentTitle: 'What’s happened?',
    disputePaymentOption1: 'I haven’t received goods, travel or services',
    disputePaymentOption2: 'I received goods that are damaged or wrong',
    disputePaymentOption3: 'I’ve been charged the wrong amount',
    disputePaymentOption4: 'I haven’t received a refund, credit or replacement',
    disputePaymentOption5: 'Something else',
    contactSellerTitle: 'Have you contacted the seller?',
    contactSellerText1:
      'Before you dispute a payment, you’ll need to try and get things resolved with the seller.',
    contactSellerText2:
      "If you've contacted them, we’ll ask for more information on what happened.",
    yesIhaveContacted: 'Yes, I’ve contacted the seller',
    contactDetailsTitle: 'Are your contact details up to date?',
    contactDetailsText:
      'We’ll use these to contact you about your dispute. If they’re wrong, please update them before continuing.',
    jointAccountUpdatesText:
      'If you’re disputing a joint account payment, we’ll send updates to the person who made the purchase.',
    editContactDetails: 'Edit contact details',
    disputeProgressStepperItems: [
      {
        id: '1',
        titleText: 'How much are you claiming?',
      },
      {
        id: '2',
        titleText: 'What didn’t you receive?',
      },
      {
        id: '3',
        titleText: 'Describe your purchase',
      },
      {
        id: '4',
        titleText: 'What happened when you contacted the seller?',
      },
      {
        id: '5',
        titleText: 'Review your dispute',
      },
    ],
    howMuchAreYouClaiming: 'How much are you claiming?',
    howMuchAreYouClaimingDescriptionText:
      'Choose ‘full refund’ if you didn’t receive anything. Choose ‘partial refund’ if you only received part of your order.',
    claimAmountValidationMessage1: 'Choose full refund or partial refund',
    partialRefundText: 'Enter the partial refund amount',
    claimAmountValidationMessage3: 'Enter an amount using numbers only',
    partialRefundAmountValidationMessage: 'Enter an amount between £0.01 and £',
    fullRefund: 'Full refund',
    partialRefund: 'Partial refund',
    whatDidntYouReceive: 'What didn’t you receive?',
    goodsText: 'Goods',
    goodsSubText: 'For example, clothing, groceries or electronics',
    travelText: 'Travel',
    travelSubText: 'For example, hotels, flights, car hire or holidays',
    servicesText: 'Services',
    servicesSubText: 'For example, home improvements or gym classes',
    describeTheGoodsHeader: 'Describe the goods',
    describeTheGoodsSubText:
      'Include the brand name, product names, sizes, colours and order numbers. Add as much detail as you can.',
    expectedDeliveryDate: 'Expected delivery date',
    describeTheGoods: 'Describe the goods',
    deliveryDateValidationMessage:
      'Enter the expected delivery date. This must be a valid date in the format DD/MM/YYYY',
    goodsDescriptionTextValidationMessage:
      'Enter a description of the goods. Include the brand, product names, colours, sizes and order numbers.',
    goodsDescriptionTextValidationMessage2: 'Enter at least 30 characters',
    goodsDescriptionTextValidationMessage3:
      'Describe the goods in 250 characters or less',
    whatHappenedWhenContactedTheSeller:
      'What happened when you contacted the seller?',
    whatHappenedWhenContactedTheSellerSubText:
      'Include how you contacted them, what you said, and what they replied with. Add as much detail as you can.',
    whenDidYouLastContactedTheSeller: 'When did you last contact the seller?',
    describeYourContactWithSeller: 'Describe your contact with the seller',
    whenDidYouLastContactedTheSellerValidationMessage1:
      'Enter the date you last contacted the seller. This must be a valid date in the format DD/MM/YYYY',
    whenDidYouLastContactedTheSellerValidationMessage2:
      'Ah, that didn’t work. Enter a description of your contact with the seller.',
    enterCurrentDateOrEarlier: 'Enter current date or earlier',
    whenDidYouLastContactedTheSellerValidationMessage4:
      'Describe your contact with the seller in  250 characters or less',
    reviewYourDispute: 'Review your dispute',
    contactDetails: 'Contact details',
    editContactDetails: 'Edit contact details',
    disputeDetails: 'Dispute details',
    editDisputeDetails: 'Edit dispute details',
    contactWithSeller: 'Contact with the seller',
    editContactWithSeller: 'Edit contact with the seller details',
    claimAmount: 'Claim amount',
    editClaimAmount: 'Edit claim amount',
    mobileNumberText: 'Mobile number',
    emailAddress: 'Email address',
    descriptionOfGoods: 'Description of goods',
    contactDate: 'Contact date',
    descriptionOfContact: 'Description of contact',
    payment: 'Payment',
    pleaseEnterValidDate: 'Please enter a valid date',
    weHaveGotItHeader: 'We’ve got it!',
    weHaveGotItDescriptionText1:
      'We’ll investigate and let you know the outcome within 14 days.',
    weHaveGotItDescriptionText2:
      'If we need more information, we’ll be in touch.',
    okGotItButtonLabel: 'Ok, got it',
    describeTheTravelBookingSubText:
      'Include the travel providers, booking references, destinations and what happened.',
    expectedDepartureDate: 'Expected departure date',
    expectedDepartureDateSubText:
      'If you had multiple bookings, use the earliest departure date.',
    expectedReturnDate: 'Expected return date',
    expectedReturnDateSubText:
      'If you had multiple bookings, use the latest return date.',
    describeTheTravelBooking: 'Describe the travel booking',
    departureDateValidationMessage:
      'Enter the expected departure date. This must be a valid date in the format DD/MM/YYYY',
    returnDateValidationMessage:
      'Enter the expected return date. This must be a valid date in the format DD/MM/YYYY',
    describeTravelBookingValidationMessage:
      'Enter a description of the travel booking. Include the travel providers, booking references, destinations and what happened.',
    departureDateValidationMessage2:
      'Expected Departure date should be before or on the same day as the return date',
    returnDateValidationMessage2:
      'Expected Return date should be after or on the same day as Expected Departure date',
    describeTheService: 'Describe the service',
    describeTheServiceSubText:
      'Include the service provider, booking references and what happened to your service.',
    expectedStartDateTitleText: 'Expected start date',
    expectedStartDateValidationMessage:
      'Enter the expected start date. This must be a valid date in the format DD/MM/YYYY',
    serviceDescriptionTextValidationMessage:
      'Enter a description of the service. Include the service provider, booking references and what happened.',
    descriptionOfTravel: 'Description of travel',
    descriptionOfServices: 'Description of services',
    travelDescriptionTextValidationMessage3:
      'Describe the travel booking in 250 characters or less',
    serviceDescriptionTextValidationMessage3:
      'Describe the service in 250 characters or less',
    cancelText: 'Cancel',

    // SO DD Diffrence Modal changes
    DDSOModalTextHeader:
      'What’s the difference between a Direct Debit and a standing order?',
    DDDefinition:
      "A <strong>Direct Debit</strong>'s a repeating payment set up by the company you’re making payments to. You normally sign a mandate that gives them permission to take money from your account – like with a gym membership or phone bill. And you're protected under the Direct Debit guarantee scheme, so if money's ever debited in error, it's refunded straight away.",
    SODefinition:
      "A <strong>standing order</strong>'s a repeating payment you’ve set up on your own to pay other people or companies, or to transfer money between your own accounts.",
    DDSOInfo:
      "You can edit or cancel standing orders as and when you like. But if you want to change a Direct Debit, you’ll have to get in touch with the company you're paying to make the changes for you.",
    DDSOModalClose: 'OK',

    refErrorMsgManagePayments:
      'Enter a reference for this payment then try again.',
    amountErrorMessage: 'Enter the amount you want to pay then try again.',
    youthAccountAmountExceededMessage:
      'The payment limit for this account is £200. Please amend and try again.',
    futureDateErrorMessage:
      'Choose the date you want the next payment to come out. This should be entered as DD/MM/YYYY.',
    nextDateErrorMessage:
      'Choose the date you want the next payment to come out. This should be entered as DD/MM/YYYY.',
    ariaLabelSinglePaymentDate: 'Choose a date for the payment to occur',
    toolTipMessageDD:
      'If you want to make changes to a Direct Debit, you’ll have to get in touch with the company you’re paying to make them for you. You can cancel a Direct Debit on your own at any time but remember to let the company know so they don’t try to take money out your account.',
    cancelDDInfo:
      'You’re about to cancel the following Direct Debit. Before you do this, it’s recommended that you get in touch with the company you’re currently paying to let them know you’re cancelling it.',
    after4pmMessage:
      'One-off payments can be cancelled up to midnight on the business day before the payment is due to leave your account, for repeating standing orders it’s 4pm the business day before. If you cancel after this time money may still leave your account.',
    after4pmMessageDD:
      'You can cancel this up to 4pm on the business day before it’s due to be paid. If you cancel it after this time, the payment may still be taken.',
    cancelledFooter:
      "That's all of them. Any archived payments will appear here.",
    downloadMobileAppForSoftTokenText:
      '<p>To continue with this <payment>, you’ll have to authorise it using one of our online security tools – or go back and reduce the amount you’re trying to move.</p><p>The quickest way to authorise payments is to download the app. Just search for <strong>‘Virgin Money – manage your money’</strong> on the Apple App Store or Google Play Store, set up the app on your mobile or tablet then come back and move your money. Simple.</p>',
    knowMoreText:
      'Need more info? Or want to find out about other ways of authorising payments? Check out the FAQs in the help section or get in touch with us.',
    reduceAmountButton: 'Ok, got it',
    goGetBText: 'Close this and go get the app',
    softTokenErrorHeading: 'Give this <payment> the OK',
    // Feature 5 Savings Pot
    internalServerError: 'Internal server error',
    savingDone: 'Done',
    SavingsAcc: 'Savings account',
    SavingLinkPot: 'Want to create a new Savings Pot?',
    SavingLinkSetupPotMobile: 'Set up a new Savings Pot',
    SavingLinkAddPotMobile: 'Add new Savings Pot',
    savingpotNoPotMobile:
      "Savings Pots are a way of saving for the \n things you've always wanted. You can \n tailor your pots using our calculator, to \n make them work within your budget. Then \n keep up to date with your progress and \n make edits as things change, as they \n always do!",
    savingpotNoSavingAccount1:
      "Savings Pots are a way of saving for the things you've always \n wanted. You can tailor your pots using our calculator, \n to make them work within your budget. Then keep up \n to date with your progress and make edits as things \n change, as they always do!",
    savingpotNoSavingAccount2:
      'To use Savings Pots, you need to open a Virgin Money Instant Savings account.',
    savingPotDeleteTitle: 'Are you sure?',
    savingPotDetailDeletMessage1:
      "Remember to cancel any regular transfers you've set up.",
    savingPotDetailDeletMessage2:
      "Don't worry all your money will stay in your savings account.",
    savingPotRejigDeletMessage1:
      "Are you sure you want to delete this Savings Pot? You won't be able to cancel the deletion afterwards.",
    savingPotRejigDeletMessage2:
      'Deleting this pot will not cancel any associated standing orders; please do this manually.',
    savingpotmessage:
      "Savings Pots are a way of saving for the things you've always\nwanted. You can tailor your pots using our calculator,\nto make them work within your budget. Then keep up\nto date with your progress and make edits as things\nchange, as they always do!\n\nTo use Savings Pots, you need to open a Virgin Money Instant Savings account.",
    savingpotNopotMessage:
      'To use Savings Pots, you need to open a Virgin Money Instant Savings account.',
    savingpotcreationcolumn1: 'I’d like to save',
    savingpotcreationcolumn2: 'Kick it off with',
    savingpotcreationcolumn6: 'My current balance is',
    savingpotcreationcolumn3: 'Have it by',
    savingpotcreationcolumn4: 'And I can put this much away a month',
    savingpotreducemessage1:
      'You need a rejig. You have taken some money out of your savings account so you need to reduce your Savings Pots by',
    savingpotreducemessage2:
      'Fancy a rejig? You have more money in your savings account than in your pots so could top them up by',
    savingpotcurrentbank: 'Current balance of account ',
    savingpottotalallocated: 'Total allocated to pots',
    savingpotcurrentbankmobile: 'Current balance',
    savingpotTitle: 'Savings Pots',
    savingpotAllocatedTitle: 'Allocated',
    savingpotTargetDate: 'Target date',
    savingpotAimingBal: " You're aiming for",
    savingpotByBal: 'by',
    savingpotByputtingAway: 'by putting away',
    savingpotAmonth: 'a month',
    savingpotMainPageTitle1: 'You have',
    savingpotMainPageTitle2: 'that could go in a Savings Pot',
    savingPotRejigTitle: 'Uh oh, fancy a rejig?',
    savingpotRejigMessage1: "You've earmarked",
    savingpotRejigMessage2:
      'more for your Savings Pot(s) than you have in this account. To make sure things add up, please do one of the following: ',
    savingpotAccountTitle: 'Savings accounts',
    savingPotCreatePotButton: 'Create pot',
    savingsPotCancelButton: 'Cancel',

    savingPotSaveButton: 'Save',
    savingPotConfirmChangeButton: 'Confirm changes',
    savingsPotNameLabel: 'Enter a name for your Savings Pot',
    savingsPotYesButton: 'Yes',
    potMessageHead1: 'Goal!',
    potMessage1Part: 'Congratulations … you’ve hit your target of',
    potMessageHead2: 'Hmmm',
    potMessage2Part1: ' Put away',
    potMessage2Part2: ' every month and you won’t hit',
    potMessage2Part3: ' unless you happen to have a time machine handy.',
    potMessage2Part4: 'Do you want to crank things up a bit?',
    potMessage2Part5: 'every month and you won’t hit',
    potMessageHead3: "It's going great",
    potMessage3Part1: 'To stay on track put away',
    potMessage3Part2: 'this month and every month ‘til your target date of',
    potMessage3Part3: 'and you’ll save',
    potMessage3Part4: 'Congrats.',
    potMessage3Part5: 'this month and every month ‘til your target date of',
    potMessageHead4: 'Happy to wait?',
    potMessage4Part2: 'this month, and you won’t hit your target of',
    potMessage4Part3: 'until',
    potMessage4Part4:
      'If that’s OK, great. If not, you might want to bring it forward to',
    potMessage4Part5: 'by upping your monthly amount to',
    potMessageHead5: "You've got wiggle room",
    potMessage5Part2: 'a month and you’ll have',
    potMessage5Part3: 'by your target date of',
    potMessage5Part4: 'Though you can reduce your monthly amount to',
    potMessage5Part5: 'and you will still hit your target by',
    potMessage5Part6: 'and you’ll still hit your target date of',
    potMessageHead6: 'Keep going',
    potMessage6Part1: "It's all going according to plan.",
    potMessageHead7: 'Think of a goal - large or small',
    potMessage7Part1:
      'How much would you need to put into a Savings Pot to make it happen?',
    potMessage8Part2: 'a month and you are unlikely to hit',
    potMessage8Part3: 'You might want to crank things up a bit.',
    potMessageHead8: 'That’s spot on',
    potMessage7Part2: 'a month, and you’ll save',
    potMessage7Part3: 'Happy days.',
    potMessage7Part4: 'It might take a while',
    potMessage7Part5: 'a month, and you’ll have',
    potMessage7Part6: "You'll smash it",
    potMessage7Part7: "and you'll have",
    potMessage7Part8: 'a month and you’ll have',
    potMessage8Part1: 'if you want to take things a bit easier and do it by',
    potMessage1: 'You will meet your goal instantly.',
    potMessage9Part1: ' Never mind',
    potMessage9Part2: " You've not hit your goal of ",
    potMessage9Part3: ' by ',
    potMessage9Part4: ' Still, why not grant yourself an extension?',
    potMessage9Part5: 'As they say, better late than never',
    potDetailMessage5Part2: 'your usual ',
    potDetailMessage5Part3: 'this month and you’ll have',
    potDetailMessage5Part4: 'by',
    potDetailMessage5Part5: 'Though you could cut your payments to',
    potDetailMessage5Part6:
      'a month and still hit your target by the same date.',
    potDetailMessage4Part2: ' this month, and you won’t hit your target of',
    potDetailMessage4Part3: ' until ',
    savingPotDeletePotButton: 'Delete Savings Pot',
    savingPotDeletePotButtonMobile: 'Delete this pot',
    savingsPotConfirmationMessage: 'Great! Your Savings Pot has been created.',
    savingsPotConfirmationTransfer:
      'Want to make a one-off transfer to kick start it now?',
    savingsPotConfirmationTransferMobile:
      'Make a one-off transfer to start it now',
    savingsPotConfirmationTransferRegular: 'Or set up a regular transfer?',
    savingPotMoveMoneyButtonMobile: 'Move money',
    savingPotMoveMoneyButton: 'Move Money',
    savingPotEditPotButton: 'Edit Savings Pot',
    savingPotEditPotButtonMobile: 'Edit this pot',
    savingPotReduceRejigButton: 'Reduce or delete Savings Pots',
    savingPotMoveMoneyButton2: 'Move money into my savings account',
    savingPotCurrencyType: 'GBP',
    savingPotCreateHeading: 'Create Savings Pot in',
    savingPotEditHeading: 'Edit my Savings Pot in',
    savingPotCreateHeadingMobile: 'Create Savings Pot',
    savingPotEditHeadingMobile: 'Edit my Savings Pot',
    savingPotDateDefaultText: 'Choose...',
    SavingPotUnallocatedText: 'unallocated',
    savingPotwayToGoHead: 'Way to go',
    savingPotReduce: 'Reduce Savings Pots',
    savingPotModalText1:
      "You've already used that name for a different Savings Pot. Please choose a different name.",
    savingPotModalText2:
      "You've not entered the Savings Pot name. Please enter a name.",
    savingpotscurrentlyunavailable1: 'Savings Pots are currently unavailable,',
    savingpotscurrentlyunavailable2: ' please try again later.',

    // Feature 5 Spendings
    spendingAccountButtonLabel: 'Accounts',
    spendingCancelButtonText: 'Cancel',
    spendingOkButtonText: 'Ok',
    spendingNextButtonText: 'Next',
    spendingSaveButtonText: 'Save',
    spendingTryButtonText: 'Try again',
    spendingDoneButtonText: 'Done',

    spendingHeaderTitle: "What you've spent this month vs",
    spendingHeaderTitle1: 'vs Budget',
    spendingHeaderTitle2: 'Spent vs',
    spendingHeaderButtonLabel: 'Your budget',
    spendingHeaderButtonLabel2: 'Create budget',
    spendingHeaderButtonLabel3: 'Edit budget',
    spendingHeaderButtonLabel4: 'Create budget',
    spendingHeaderButtonLabel5: 'Edit budget',
    spendingHeaderThisMonthText: 'This month',
    spendingHeaderNoBudgetWatning:
      'Setting up a budget helps you plan your spending each month.',
    spendingHeaderNoBudgetWatning1:
      'Setting a budget helps you plan your spending each month',
    spendingHeaderNoBudgetTitle: "Here's where things get interesting.",
    spendingHeaderNoBudgetMessage:
      "There's not much to see here yet, but as you start spending you'll see how you're doing against previous months.",
    spendingHeaderBudgetText: 'Budgeted',
    spendingProgressText1: 'Budget',
    spendingProgressText2: 'Pots',
    spendingProgressText3: 'Income',
    spendingDaysLeftText: 'days left in this month',
    spendingTableHeaderText1: 'Tag',
    spendingTableHeaderText2: 'Spent this month',
    spendingTableHeaderText3: 'Amount budgeted',
    spendingTableHeaderText4: 'Status',
    spendingTableHeaderText5: 'Difference',
    spendingTableHeaderText6: 'Spent in',
    spendingTableHeaderText7: 'Last month',
    spendingTableHeaderText8: 'Budget',
    spendingTableHeaderText9: 'Date',
    spendingTableHeaderText10: 'Description',
    spendingTableHeaderText11: 'Type',
    spendingTableHeaderText12: 'Tag',
    spendingTableHeaderText13: 'Amount',
    spendingTableHeaderText14: 'Account',
    spendingTableLoading: 'Loading data...',
    spendingTableLoading1: 'No transactions found',
    spendingTableMessage1: 'Great news, you have no untagged transactions.',
    spendingTableMessage2: 'How about tagging these transactions?',
    spendingTableMessage3: 'over budget!',
    spendingTableMessage4: 'left to spend',
    spendingTableMessage5: 'No budget set yet',
    spendingTableMessage6: 'more than last month',
    spendingTableMessage7: 'less than last month',
    spendingTableMessage8: 'no difference!',
    spendingTableMessage9: 'Nothing left to spend',
    spendingTableMessage10: 'No budget',
    spendingEarningMessage:
      "Here are your anticipated monthly earnings. Please change the amount if it's not quite right.",
    spendingEarningMessage1: 'Please enter your anticipated earnings',
    spendingCreateHeaderLeftLabel: 'Pots and budget',
    spendingCreateHeaderRightLabel: 'Earnings',
    spendingCreateMessageTitleText1: 'Nice',
    spendingCreateMessageTitleText2: 'Uh oh, fancy a rejig?',
    spendingCreateMessageCopyText1: 'Your budget this month is',
    spendingCreateMessageCopyText2: " and you're hoping to save",
    spendingCreateMessageCopyText3: 'This means you have',
    spendingCreateMessageCopyText4: 'left over.',
    spendingCreateMessageCopyText5: "This means you're short by",
    spendingCreateMessageCopyText6: 'You have',
    spendingCreateMessageCopyText7: "You're short by",
    spendingCreateMessageCopyText8: 'Your budget is',
    spendingCreateMessageCopyText9: 'left over',
    spendingPotTooltipMessage:
      'You can edit the amount allocated to your Saving Pots in the pots screen later',
    spendingJointTooltipMessage:
      'These are joint tags that your joint account holder has created. You can still allocate budget to them',
    spendingTransitionHeaderText1: 'Your',
    spendingTransitionHeaderText2: 'transactions',
    spendingTransitionInProgressHeaderText: 'In progress',
    spendingTransitionInProgressMessage: 'This is still going through.',
    spendingNoSpendTitle: 'Spending',
    spendingNoSpend: 'We were unable to load your spending at this time.',
    spendingCloserLook: 'Take a closer look',
    csrText: 'Current savings interest rate <strong>amount% AER</strong>',
    savingspotTileText: 'Set up pots, save up lots',
    savingspotTileBtnLabel: 'Go to Savings Pots >',
    fsCloserLook: 'Take a closer look.',

    // Homepage
    warningIconTextProjection: "Uh oh, looks like you're running low.",
    warningIconTextRejigCase:
      'Uh oh, you’ve earmarked more for your Savings Pot(s) than you have in this account.',
    // Products
    productPageTitle: 'ProductsPage',
    products: 'Products',
    productsContent1:
      "We're working hard to bring you super-handy products to help you manage your money.",
    productsContent2:
      'Before you check them out, here are some details to keep in mind. Fees and charges may apply to some of these products and security may be needed too. All credit facilities are subject to status and age restrictions may also apply.',
    productsContent3:
      'These links will open in a new window or tab. If you like what you see and don’t come back in 5 minutes, you’ll be automatically logged out of internet banking.',
    productHeadErrorMessage:
      'We were unable to load your products at this time.',
    productBodyErrorMessage: '',
    // Business Product
    businessProducts: 'Products',
    businessProductsContent: `We're working hard to bring you the products your business needs. You can find out more about what's on offer by checking out our full product range.`,
    businessProductsContent1: `These links will open in a new window or tab. If you like what you see and don't come back in 5 minutes, you'll automatically be logged out of Business Internet Banking.`,

    logOutWarningText:
      'If you like what you see and don’t come back in 5 minutes, you’ll be automatically logged out of internet banking.',
    productsModelContent:
      'This link will open in a new window or tab and will take you out of internet banking. If you like what you see and don’t come back in 5 minutes, you’ll be automatically logged out.',
    productsModelNonBProductContent:
      'This product is powered by XXXXX Bank.<br/><br/>This link will take you out of internet banking to the XXXXX Bank website and will open in a new window or tab.<br/><br/>If you like what you see and don’t come back in 5 minutes, you’ll be automatically logged out.',
    modalHeading: 'Opening in new window',
    modalFooter: '',
    productsFooterText:
      "Your home may be repossessed if you don't keep up repayments on your mortgage",
    cancelButtonText: 'Cancel',
    continueButtonText: 'Continue',
    nonBContinueButtonText: 'Continue to XXXXX ',
    activateHardTokenHeading: 'Activate security token',
    activateHardTokenDescription:
      'Activate your token now to get even more protection when you bank online.',
    activateHardTokenLink: 'Activate it',

    // Error page text
    errorText1: 'Something’s gone wrong',
    errorText2: 'Hmm. Looks like there’s been a technical problem.',
    errorText3:
      'Log out then log back in to try again. Still not working? Get in touch with us.',

    // BOW Error Messages.
    AmountErrorMsg: 'Amount is required!',
    AmountErrorMsgLimit: 'value must be less than £500.00',
    CompanyErrorMsg: 'Compnay is required!',
    NameErrorMsg: 'Name is required!',
    NickNameErrorMsg: 'Nick name is required!',
    SortCodeErrorMsg: 'Sort code is required!',
    SortCodeErrorMsgLimit: 'Sort code is required!',
    AccNumErrorMsg: 'Account number is required!',
    radioErrorMsg: 'Radio selection required!',
    checkboxErrorMsg: 'Checkbox selection required!',

    fsTileErrorHeading: "We can't show you this story right now.",
    fsTileErrorButtonLabel: "We'll keep trying though…",

    // Chat tile Display Messages
    chatHeading: 'Want to chat?',
    chatDescription:
      'The Virgin Money team will keep chat transcripts for training, legal and compliance reasons.',
    genericChatSubheading: 'Launch live chat to talk to us now.',
    // Generic Chat Tile Display Messages
    genericChatHeading: 'Need help? Chat to us',
    genericChatDescription:
      'The Virgin Money team will keep chat transcripts for training, legal and compliance reasons.',
    genericChatButtonText: 'Launch live chat',

    helmetTitlePaper: 'Order a paper statement',
    titlePaper: 'Order a paper statement',
    mainDescriptionPaper:
      'Did you know that online statements are available on both internet banking and our mobile app?',
    subDescriptionPaper: undefined,
    linkNamePaper: 'View, download or print an online statement',
    orderButtonNamePaper: 'Order now',
    modelTitlePaper: "Your statement's on its way",
    subContent1: 'Need a paper copy of your statement? ',
    callUsText: 'Give us a call',
    subContent2:
      ' and we’ll send it to your registered address within 7–10 business days.',

    // order cheque book
    helmetTitleCheque: 'Order a new cheque book',
    titleCheque: 'Order a new cheque book',
    mainDescriptionCheque:
      'Already had a cheque book for this account? Go ahead and order a new one now.',
    mainDescription2Cheque:
      'We’ll send it to your registered address within 7–10 business days.',
    subDescriptionCheque: 'Give us a call and we’ll get one ordered for you.',
    subTitleCheque: 'Never had a cheque book before?',

    orderButtonNameCheque: 'Order now',
    modelTitleCheque: 'Your cheque book’s on its way',
    modelBodyContentCheque:
      'Happy days. Your new cheque book will be popped through your letterbox within 7–10 business days.',
    modelOkButtonCheque: 'OK',
    // order payin
    helmetTitlePayin: 'Order a new pay-in book',
    titlePayin: 'Order a new pay-in book',
    mainDescriptionPayin:
      'Already had a pay-in book for this account? Go ahead and order a new one now.',
    mainDescription2Payin:
      'We’ll send it to your registered address within 7–10 business days.',
    subDescriptionPayin: 'Give us a call and we’ll get one ordered for you.',
    subTitlePayin: 'Never had a pay-in book before?',

    orderButtonNamePayin: 'Order now',
    modelTitlePayin: 'Your pay-in book’s on its way',
    modelBodyContentPayin:
      'Happy days. Your new pay-in book will be popped through your letterbox within 7–10 business days.',
    modelOkButtonPayin: 'OK',
    // CMA Alerts
    alertAccountPageHeading: 'Manage your alerts',
    alertAccountPageDescription:
      'Our handy alerts help you stay in control and keep track of your money. Choose what account you want to manage the alerts for.',
    alertAccountPageFooterDescription:
      'Got an account that’s not here? Alerts are only available for the accounts shown above right now.',

    alertListHeading: 'Manage your alerts',
    alertListDescription:
      'Got another account? Alerts are only available for this one right now.',
    alertListCMAHeading: 'Take action alerts',
    alertListCMASubHeading:
      'Send me a text when my account balance is too low to cover a payment or if a payment takes me into unarranged overdraft.',
    alertListCMAMoreButtonName: 'Find out more',
    alertListCMASubDescription:
      'These alerts will let you know when you’ll have to pay money in for payments to go through or to avoid an unarranged overdraft and possible charges. Want to turn them off? That’s totally up to you – but they may help you avoid fees and charges.',
    alertListCustomAlertHeading: 'Custom alerts',
    alertListWBHeading: 'Weekly balance update',
    alertListWBcontentDesc: 'Send me a text every',
    alertListWBContentSubDec: 'to let me know how much I’ve got in my account.',
    alertListHighAlertHeading: 'High balance alert',
    alertListHighAlertContentDesc: 'Send me a text when I’ve got more than',
    alertListHighAlertContentSubDesc: ' in my account.',
    alertListLowAlertHeading: 'Low balance alert ',
    alertListLowAlertContentDesc: 'Send me a text when I’ve got less than',
    alertListLowAlertContentSubDesc: ' in my account.',
    alertListSweepHeading: 'Sweep',
    alertListSweepDesc: 'When I’ve got less than',
    alertListSweepDesc2: 'in this account, move money into it from my',
    alertListSweepDesc3: 'account to take me back up to',
    alertListProjectionHeading: 'Projected low balance alert',
    alertListProjectionSubDesc:
      'Send me a text when my projected balance is less than',

    alertWBHeading: 'Weekly balance update',
    alertWBSubHeading:
      'Send me a text to let me know how much I’ve got in my account every',

    alertHighBalanceHeading: 'High balance alert',
    alertHighBalanceSubDesc: 'Send me a text when I’ve got more than',

    alertLowBalanceHeading: 'Low balance alert',
    alertLowBalanceSubDesc: 'Send me a text when I’ve got less than',

    alertSweepHeading: 'Sweep',
    alertSweepSubDesc1: 'When I’ve got less than',
    alertSweepSubDesc2: 'Move money from',
    alertSweepSubDesc3: 'To take me back up to',
    alertSweepAmountDiffMessage:
      'There has to be at least £100 between each amount. So if you’ve got less than £50, you’ll have to go back up to £150 or more.',

    alertProjectionHeading: 'Projected low balance alert',
    alertProjectionDesc:
      'Send me a text when my projected balance is less than',

    cancelButtonName: 'Cancel',
    confirmButtonName: 'Confirm',

    sweepModalHeading: 'Switch off Sweep?',

    sweepModalBody1:
      'Personalised any amounts? If you switch this back on, you’ll have to set them up again from scratch.',
    sweepModalBody:
      "This won't just switch off the alert you get – it'll switch off the Sweep that moves money into your account too.",

    sweepModalSwitchOffCancel: "Don't switch off",
    sweepModalSwitchOffOkay: 'OK, switch off',

    // Account Reorder
    accountReorderHeader: 'Change account order',
    accountReorderHeader1:
      "Here's the order your accounts will be shown in when you're on internet banking.",
    accountReorderFavouritesHeader:
      'This is the order your favourite accounts will appear within Business Internet Banking.',
    accountReorderAddFavourites:
      'You can only change the order of accounts you’ve marked as favourites.',
    arrowButtonsUseTip:
      'Change the order of your accounts using the arrow buttons below.',

    eGainChatModelHeader: 'Launching live chat',
    eGainChatModelText:
      'We’re opening live chat in a new window. If you don’t use internet banking for 5 minutes, you’ll be automatically logged out while you chat.',
    eGainChatModelButtonText: 'OK, chat now',
    clearedBalance: 'Cleared balance',
    isaTaxYearDisplayText: 'Subscriptions made so far this tax year',
    isaTotalDepositDisplayText: 'Maximum you can still put in this tax year',
    isaTaxYearDepositExplanationText:
      'This amount is the total of all the money you’ve put in minus any withdrawals from this cash ISA in this tax year. Want to find out more about ISA limits and rules? Check out the ',
    isaTotalDepositExplanationText:
      'This amount is only based on the money you’ve put into or taken out of this cash ISA. If you’ve put money in other types of ISA this tax year, you might not have this much left. Want to find out more about ISA limits and rules? Check out the ',
    // Payment SME Contents
    paymentSMEHeader: 'Pay or transfer money',
    paymentSMESubHeader:
      'Pay a bill, person or organisation or transfer money between your accounts. You can save time by setting up repeating transactions or making multiple payments and transfers at the one time.',
    paymentSMEUnauthorisedSubHeader:
      'You don’t have permission to make payments and transfers. Please contact your corporate administrator for more information',
    multiplePaymentQuickLink: 'Make multiple payments',
    smeReviewWarningHeader: `Your payment hasn't been made yet`,
    smeReviewWarningBody:
      "If you leave this page now, your transaction won't be completed.",
    leaveThePage: 'Leave page',
    continueWithPayment: 'Continue with payment',
    paymentCOPUrl: 'https://uk.virginmoney.com/service/cop/',

    // Fate of payment content
    quickLinkPaymentStatus: 'Payments status and history',
    paymentHistoryToolTipMessage:
      'The payments list only shows payments you’ve made within mobile and internet banking. It doesn’t include transactions you’ve made with your debit card, for example, or Direct Debits taken by companies. You can view these in your transaction list on the account page.',
    paymentHistoryListHeader: 'Payment list',
    paymentHistoryNoDataMsg: 'No payments found. Try changing your date range.',
    paymentHistoryMobileNoDataMsg:
      'No payments found. You can only see your last three months payments using your mobile device.',
    paymentHistoryFilterFromErrorMsg:
      'Something’s not right there. Make sure the date you’ve entered is less than 13 months ago and before the date you want to view your payments up to',
    smePaymentHistoryFilterFromErrorMsg:
      'Something’s not right there. Make sure the date you’ve entered is less than 18 months ago and before the date you want to view your payments up to',
    paymentHistoryFilterToFieldErrorMsg:
      'Something’s not right there. Make sure the date you’ve entered isn’t in the future or before the date you want to view your payments from',
    paymentHistoryFooterMsg:
      'That’s all we can find. Try changing your date range.',
    paymentHistoryMobileFooterMsg:
      'That’s all we can find. You can only see your last three months payments using your mobile device.',
    showMore: 'Show more',
    accountPickerLabel: 'Accounts',
    searchPaymentHistoryEmptyMsg:
      'No payments found. Try changing your search criteria.',
    paymentHistoryNoTransactionMsg:
      'No payments found. Try changing your date range or payment status',

    // Secure Message
    communicationsHub: 'Communications Hub',
    secureMessages: 'Secure messages',
    youGot: "You've got ",
    newSecureMessages: ' new secure messages',
    oneSecureMessage: ' new secure message',
    messageTitle: 'Message',
    messageContent:
      'Share your details with the Virgin Money team and get all the help you need. It’s simple, safe and secure.',
    newSecureMessage: 'Secure messaging',
    leaveMessageUsTitle: "Oops, your message hasn't sent yet",
    leaveMessageUsBody:
      "Sure you want to leave this page? If you do, your message won't be sent or saved as a draft.",
    leaveMessageUsPrimaryButtonText: 'Continue with message',

    // Secure Message Lets chat Modal
    letsChatModalTitle: "Looking for help? Let's chat",
    youCanSendMessage:
      'You can now send and receive secure messages in a flash with our new instant message service.',
    manyCustomersAreUsingMsg:
      'Many customers are already getting help and advice right away, just by selecting Let’s chat.',
    withLetsChatMsg: 'With Let’s chat, you can:',
    withLetsChatDescList: {
      getInTouchMsg: 'Get in touch day or night',
      getAnInstantReplyMsg: 'Get an instant reply',
      manageYourAccountMsg:
        'Manage your account and chat with us at the same time',
    },
    easyToUseMsg:
      "It’s easy to use, and you’ll still be able to access the current service as normal. Just remember, you won't see your old secure messages in Let’s chat.",
    continueToSecMsgBtnTxt: 'Continue with secure messaging',
    letsChatBtnTxt: 'Let’s chat',
    dontShowAgainMsg: 'Don’t show this again',

    ibanAndBicInfo:
      'If someone’s sending you money from abroad, you’ll have to give them your IBAN (International Bank Account Number) and BIC (Bank Identifier Code) to receive your payment.',
    authorisationAlertSingularMsg: 'You’ve got a ',
    authorisationAlertPluralMsg: 'You’ve got ',
    authorisationAlertSingularAnchorBody: 'payment to authorise.',
    authorisationAlertPluralAnchorBody: 'payments to authorise.',
    // Beneficiary copy
    benSyncLandingHeader: 'Bring your payees over',
    benSyncLandingSubHeader1:
      'It’s time to move your payees from our old internet banking service over. Simply pick the ones you want and they’ll be available on internet banking and the app. Easy peasy.',
    benSyncLandingSubHeader2:
      'FYI: Any payees you transfer over will be visible to other account holders on your joint account.',
    benSyncPickPayee: 'Pick your payees',
    benSyncPayeeFound: 'payee found',
    benSyncPayeesFound: 'payees found',
    benSyncColumnHeaderName: 'Payee name',
    benSyncColumnHeaderNickname: 'Nickname',
    benSyncColumnHeaderAccNo: 'Sort code and account number',
    benSyncColumnHeaderReference: 'Reference',
    benSyncFooterMessage:
      'That’s them all. Only payees that you’ve paid in the last 12 months can be moved overB.',
    benSyncButton: 'Bring payees over',
    benSyncNoPayeeSelected:
      'Validation message if the customer doesn’t select any payees: Oops, you’ll have to pick at least one payee to continue.',
    benSyncCancelPopupHeader: 'Sure you want to cancel?',
    benSyncCancelPopupBody:
      'If you cancel now, none of your payees will be moved over.',
    benSyncPopupYesButton: 'Yes, cancel',
    benSyncPopupNoButton: "No, don't cancel",
    benSyncSuccesHeader: 'All done',
    benSyncSuccesBody: 'Your payees have been successfully moved over.',
    benSyncNoPayeeHeader: 'Nothing to see here',
    benSyncNoPayeeBody:
      'Hmm, looks like you don’t have any payees to bring across. Only payees that you’ve paid in the last 12 months can be moved over to us.',
    benSyncCalloutBody:
      'You can now move your payees from our old internet banking service over to us. Simply pick the ones you want and they’ll be available on internet banking and the app. Easy peasy.',
    benSyncCalloutBody1:
      'FYI: Any payees you transfer over will be visible to other account holders on your joint account.',
    benSyncCalloutHeader: 'Bring your payees over',
    benSyncCalloutButton: 'OK, get started',
    benSyncChooseAccountHeader: 'Choose what account to link these payees to',
    benSyncChooseAccountBody:
      "You'll still be able to move money to these payees from your other accounts.",
    benSyncChooseAccountInlineError:
      'Oops, you’ll have to choose an account to continue.',
    selectAll: 'Select All',

    // SME Payment History
    smePaymentHistoryTitle: 'Payment status and history',
    smePaymentHistoryIntroduction:
      'Keep track of the payments and transfers you’ve made from internet banking or your mobile banking app.',

    // Paperless Preferences
    paperlessReasonsTitle: 'Going digital with letters and statements',
    paperlessReason1:
      'Easy to find, view and download - no more searching through your cupboards or drawers to find your documents',
    paperlessReason2:
      'Reduces your filing, shredding or recycling chores - reducing paper waste',
    paperlessReason3:
      'Securely stored and available online 24/7 within internet banking and the mobile app - no need to wait for the post',
    paperlessReason4:
      'Change your preferences at any time or get in touch if you need a paper copy',
    paperlessReason5:
      'Email alerts let you know when a new digital statement or document is available.',
    preferencesUpdatedBody:
      'If a document has just been issued it may be the following month before your updated preferences take effect.',
    preferencesUpdatedTitle: 'Your preferences have been updated',
    paperlessInfoTitle: 'Important information',
    paperlessInfoBody1:
      'By tapping the button below, you are agreeing to receive communications from the Bank digitally, including statements. We’ll send you an email whenever a new document is available so it is important to keep your contact details up-to-date. All digital communications will be available to view, print or download from within internet banking and the mobile app. We may continue to send you some statements or documents by post. If you currently receive communications from us in Braille, large text or audio these will stop, however you can change your preferences at any time.',
    paperlessInfoBody2:
      'For joint account holders, you are choosing this option for both of you - so it’s worth checking that the other account holder is happy with this first.',
    preferencesUpdateErrorTitle: 'Sorry, something has gone wrong.',
    preferencesUpdateErrorBody1:
      'Your paper-free preferences have not been updated.',
    preferencesUpdateErrorBody2: 'Please try again later.',
    preferencesAcceptClick: 'Make me paper-free where possible',
    preferencesManageClick: 'Let me choose my paper-free accounts',
    projectionErrorBody:
      "Hmm. Looks like something's gone wrong in the background while loading your Projections. Why not give it another go?",
    projectionButtonTitle: 'Try again',

    preferencesPopupWarningHeaderAuto: 'You haven’t confirmed your changes yet',
    preferencesPopupWarningHeaderManage:
      'You haven’t confirmed your preferences',
    preferencesPopupWarningBodyAuto:
      'Please, review and confirm your preferences before moving on.',
    preferencesPopupWarningBodyManage:
      'You’ve changed your paper-free preferences but haven’t confirmed them yet',
    preferencesContinuePageBtn: 'Review and confirm changes',
    preferencesLeavePageBtn: 'Discard changes',

    accountStatusHeaderContent: "Can't load account details",
    accountStatusBodyContent:
      "Hmm. Looks like something's gone wrong in the background while loading your account details. Let's give it another go.",

    // otp
    authorisationFailedHeader: 'Something’s not right there',
    authorisationFailedBody:
      'The details you’ve entered haven’t been recognised, so for security reasons, you’ve been logged out of internet banking. To continue with your payment, you’ll have to log back in and start again.',

    //Account picker (Large Customer View)
    accountPickerModalTitle: 'You’ve added all your favourites',
    accountPickerModalContent:
      'You can only set up to 30 favourite accounts. If you’d still like to add this account as a favourite, you can unselect another account by clicking or tapping the star.',
    accountPickerPaymentsChoose:
      'Choose an account to view it’s payment status and history.',
    accountPickerManagePaymentsChoose:
      'Choose an account to view any scheduled payments.',
    accountPickerPageTitle: 'Account',
    accountPickerPageBack: 'Back',
    accountPickerLauncherButton: 'Choose account',
    accountPickerTitle: 'Account',
    accountPickerSelectedButton: 'Change account',
    accountDropDownTitle: 'Account',
    manageAccountPools: {
      accountPoolsTitle: 'Account pools',
      createAccountPool: 'Create account pool',
      noAccountPoolExist:
        'There’s nothing to see yet. Create an account pool if you want to see the combined balances and transactions of more than one business account at a glance.',
      createFirstAccountPool: 'Create first account pool',
      accountPoolHeading: 'View the account pool to make any changes.',
    },
    //Create Account Pool
    yourAccountType: {
      fieldHeader: 'Notional Currency',
      fieldOptions: [
        {
          value: 'GBP',
          label: 'GBP Pound Sterling',
        },
        {
          value: 'EUR',
          label: 'EUR Euro',
        },
        {
          value: 'USD',
          label: 'USD US Dollar',
        },
        {
          value: 'other',
          label: 'Other',
        },
      ],
    },
    createPoolButtonText: 'Create Pool',
    savePoolButtonText: 'Save Pool',
    subHeadingCreatePool: 'Select account to add to this pool.',
    subHeadingUpdatePool: 'Select account to add or remove from this pool.',
    subSectionHeading: 'Choose two or more to save.',
    accountsSelected: 'accounts selected ',
    createAccountPool: 'Create Account Pool',
    editAccountPool: 'Edit Account Pool',
    nameofPool: 'Name for this pool of accounts',
    deletePool: 'Delete Pool',
    selectAccountCreateMsg: 'Select accounts to add to this pool',
    selectAccountEditMsg: 'Select account to add or remove from this pool',
    selectAccount: 'Select account to add to this pool',
    chooseAccountValidationMessage: 'Choose two or more to save.',
    deletePoolModalTitle: 'Sure you want to delete this pool?',
    deletePoolModalBody:
      'You’ll still be able to view accounts in this pool individually.',
    dismissDeleteAccountPoolButton: 'No, keep pool',
    confirmDeleteAccountPoolButton: 'Yes, delete pool',
    createAnotherPoolButton: 'Create Another Pool',
    editPoolButton: 'Edit Pool',
    deletePoolButton: 'Delete Pool',
    viewPoolScreenTitle: 'Account pool details',
    poolDetailPanelText:
      'Available balances include pending transactions, so it shows what’s available right now',
    errorMessages: {
      poolNameEmptyErrorMessage:
        "Hmm, looks like we're missing something. Can you pick a name for this account pool using only letters, numbers, spaces and simple characters like hyphens or full stops?",
      poolNameInvalidErrorMessage:
        "Ah, that didn't work. Can you try again by picking a pool name using only letters, numbers, spaces and simple characters like hyphens or full stops?",
      notionalCurrencyMessage: 'Please select currency',
    },
    currencies: [
      { id: 'CZK', label: 'Czech Koruna', shortCode: 'CZK' },
      { id: 'NZD', label: 'New Zealand Dollar', shortCode: 'NZD' },
      { id: 'SAR', label: 'Saudi Riyal', shortCode: 'SAR' },
      { id: 'PLN', label: 'Polish Zloty', shortCode: 'PLN' },
      { id: 'THB', label: 'Thai Baht', shortCode: 'THB' },
      { id: 'INR', label: 'Indian Rupees', shortCode: 'INR' },
      { id: 'DEM', label: 'German Mark', shortCode: 'DEM' },
      { id: 'CHF', label: 'Swiss franc', shortCode: 'CHF' },
      { id: 'FRF', label: 'French franc', shortCode: 'FRF' },
      { id: 'SEK', label: 'Swedish Krona', shortCode: 'SEK' },
      { id: 'DKK', label: 'Danish Krone', shortCode: 'DKK' },
      { id: 'ITL', label: 'Italian Lira', shortCode: 'ITL' },
      { id: 'NOK', label: 'Norwegian krone', shortCode: 'NOK' },
      { id: 'BEF', label: 'Belgian Franc', shortCode: 'BEF' },
      { id: 'CAD', label: 'Canadian Dollar', shortCode: 'CAD' },
      { id: 'AUD', label: 'Australian Dollar', shortCode: 'AUD' },
      { id: 'HKD', label: 'Hong Kong Dollar', shortCode: 'HKD' },
      { id: 'SGD', label: 'Singapore Dollar', shortCode: 'SGD' },
      { id: 'ATS', label: 'Austrian shilling', shortCode: 'ATS' },
      { id: 'ZAR', label: 'South African rand', shortCode: 'ZAR' },
      { id: 'AED', label: 'United Arab Emirates Dirham', shortCode: 'AED' },
      { id: 'MYR', label: 'Malaysian Ringgit', shortCode: 'MYR' },
      { id: 'JPY', label: 'Japanese Yen', shortCode: 'JPY' },
      { id: 'NLG', label: 'Dutch Guilders', shortCode: 'NLG' },
      { id: 'IRP', label: 'Irish Punt', shortCode: 'IRP' },
    ],
    popularCurrencies: ['GBP', 'EUR', 'USD'],
    confirmationOfPayeeContent: {
      noPreviousCheckHeader: 'Name not checked',
      noPreviousCheckDescription:
        "We've not checked this account with the name-matching service before. For added security, please review their details before continuing.",
      noPreviousCheckButton: 'Check now',
    },
  };

  // Address validations. There is a max of 15 so create 15 of these.
  for (var i = 0; i < 15; i++) {
    result['addressPrefix_' + i + 'ValidationMessage'] =
      'Sorry, your flat number must be written using numbers and letters only and no longer than 40 characters.';
    result['addressPrefix_' + i + 'HelpMessage'] =
      'This is the flat number of your house or apartment.';
    result['houseNumber_' + i + 'ValidationMessage'] =
      'Sorry, your house number must be written using numbers and letters only and no longer than 40 characters.';
    result['houseNumber_' + i + 'HelpMessage'] =
      'This is the number of your house or apartment.';
    result['houseName_' + i + 'ValidationMessage'] =
      'Sorry, your house name must be written using numbers and letters only.';
    result['houseName_' + i + 'HelpMessage'] =
      'This is the name of your house or apartment.';
    result['streetName_' + i + 'ValidationMessage'] =
      'Your street name should be written using numbers and letters only and be no longer than 40 characters.';
    result['streetName_' + i + 'HelpMessage'] =
      'Your street name should be written using number and letters only.';

    for (var j = 1; j < 5; j++) {
      result[['addressLine', j, '_', i, 'ValidationMessage'].join('')] =
        'Your address line ' +
        j +
        ' should be written using numbers and letters only and be no longer than 40 characters.';
      result[['addressLine', j, '_', i, 'HelpMessage'].join('')] =
        'Your address line ' +
        j +
        ' should be written using number and letters only.';
    }

    result['city_' + i + 'ValidationMessage'] =
      'Your town should be written using numbers and letters only and no longer than 40 characters.';
    result['city_' + i + 'HelpMessage'] =
      'Please tell us which town or city this address is in.';
    result['county_' + i + 'ValidationMessage'] =
      'Your county should be written using numbers and letters only and no longer than 40 characters.';
    result['county_' + i + 'HelpMessage'] =
      'Please tell us which county this address is in.';
    result['country_' + i + 'ValidationMessage'] =
      'Please select a valid option from the dropdown.';
    result['country_' + i + 'HelpMessage'] =
      'Your current address must be in the UK, but for previous addresses, please tell us which country you lived in.';
    result['dateMoved_' + i + 'ValidationMessage'] =
      "For current addresses, the date you moved in needs to be before today. If it's a previous address, it should be an earlier date than any addresses listed above it.";
    result['dateMoved_' + i + 'HelpMessage'] =
      'Please enter the day month and year you moved to this address.';
    result['postcode_' + i + 'ValidationMessage'] =
      "Please check as this postcode can't be found. Postcodes are normally formatted like this - A12 3BC - if yours still can't be found please call us on " +
      brand.phoneNumber +
      '.';
    result['postcode_' + i + 'HelpMessage'] =
      'You need to supply a valid postcode for any UK address you add. These are normally formatted like this: A12 3BC. If you live at a BFPO address, please call us.';
  }

  return Object.freeze(result);
};
